<template>
  <v-col v-dirkeydown="keyRightLeft" class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12" v-resize="onResize"> {{ ActDescBtn }}

    <!--  Modales -->
    <!-- ------------------------------------------------------   alerta -->
    <v-snackbar v-model="aalert.estado" :color="aalert.color" :type="aalert.type" id="alerMov" :vertical="true"
      :timeout="120000" top="top">
      {{ aalert.nombre }}
      <v-btn dark text @click="aalert.estado = false">Close</v-btn>
    </v-snackbar>
    <!-- ------------------------------------------------------  fn alerta -->


    <!-- ------------------------------------------------------ Modal- crear Producto-->
    <v-dialog transition="fab-transition" label="Modal agregar producto" v-model="dialogCrearProducto">
      <v-card>
      <CrearProducto @EmitCrearProducto="RecCrearProducto" />
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------ fn Modal- crear producto-->

    <!-- ------------------------------------------------------ Modal- Crear Producto Movil-->
    <v-dialog v-model="dialogCrearProductoMovil" transition="fab-transition" >
      <v-card class="overflow-x-hidden">
        <CreacionProductoMovil :isDialogMode="true" @closeCreacionProductoDialog="dialogCrearProductoMovil = false" />
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------ fn Modal- crear producto-->


    <!-- ------------------------------------------------------ Modal- nueva Produecto-->
    <v-dialog transition="fab-transition" label="Modal agregar producto" v-model="dialogAddProducto" persistent
      max-width="90%" max-height="80%">

      <div v-if="this.$store.getters.GetConfiguracionGeneral.config.distribuidoraFarmaceutico==false">
         <AgregarProducto :statusFoms="dialogAddProducto" ref="RefAgregarProducto" :PropsFacturaProveedor="PropsFacturaProveedor"
        @EmitAgregarProducto="RecAgregarProducto" :unidadminima="PropsUnidadminima" />
      </div>

      <div v-if="this.$store.getters.GetConfiguracionGeneral.config.distribuidoraFarmaceutico==true">

        <!-- <AgregarProducto v-if="PropsFacturaProveedor==true" :statusFoms="dialogAddProducto" ref="RefAgregarProducto" 
        @EmitAgregarProducto="RecAgregarProducto" :unidadminima="PropsUnidadminima" />-->

        <AgregarProductoDistFarma :PropsFacturaProveedor="PropsFacturaProveedor" :statusFoms="dialogAddProducto" ref="RefAgregarProducto"
        @EmitAgregarProducto="RecAgregarProducto" :unidadminima="PropsUnidadminima" />

      </div>


    </v-dialog>
    <!-- ------------------------------------------------------ fn Modal- nueva producto-->




    <!-------------------------------------------------------- Modal Producto Sugerido -->
    <v-dialog transition="fab-transition" label="Modal agregar factura" v-model="dialogVerOtroAlmacen" persistent
      max-width="90%" max-height="80%">
      <v-card>
        <v-toolbar flat color="indigo" dense>

          <i style="font-size: 20px;" class=""> </i>
          <v-toolbar-title style="color:white;" class="font-weight-light"> <b>LISTADO DE ALMACENES</b></v-toolbar-title>
          <i style="font-size: 20px;" class=""> </i>

          <v-spacer></v-spacer>
          <v-btn color="grey darken-4" fab small @click="dialogVerOtroAlmacen = false">
            <i style="font-size: 20px; color:white;" class="fa fa-close"></i>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <br>

          <v-row>





            <v-col v-if="OtroAlmacen != null" class="pa-0 ma-0 py-0 my-0 black--text" cols="12" md="12" sm="12">
              <p class="pa-0 ma-0 py-0 my-0" style="border: 1px dashed  #616161;"><b>PRODUCTOS:</b>
                {{ OtroAlmacen.unidadProducto.productos.descripcion }}</p>
              <p class="pa-0 ma-0 py-0 my-0" style="border: 1px dashed  #616161;">
                <b>COSTO:</b>{{ currencyFormatter(OtroAlmacen.unidadProducto.costo) }}
              </p>

              <v-card style="border: 1px solid  #616161;">

               <v-lazy  v-model="isActive" :options="{  threshold: .5 }" min-height="500"  transition="fade-transition">
               <v-data-table :headers="[
                  { text: 'ALMACEN', value: 'almacen', sortable: false, class: ['no-gutters black--text'] },
                  { text: 'EXISTENCIA', value: 'existencion', sortable: false, class: ['no-gutters black--text'] },
                  { text: 'VENTAS', value: 'venta', sortable: false, class: ['no-gutters black--text'] },
                  { text: 'CANT. PENDIENTE A ENTREGAR', value: 'pendienteEntregar', sortable: false, class: ['no-gutters black--text'] },
                ]" dense :items="OtroAlmacen.ListaAlmacen" :items-per-page="15">

                  <template v-slot:item.venta="props">
                    <span style="font-size:13px;">{{ currencyFormatter(props.item.venta) }}</span>
                  </template>

                  <template v-slot:item.almacen="props">
                    <span style="font-size:13px;">{{ props.item.almacen }}</span>
                  </template>

                  <template v-slot:item.existencion="props">
                    <span style="font-size:13px;">{{ props.item.existencion }}</span>
                  </template>

                  <template v-slot:item.pendienteEntregar="props">
                    <span style="font-size:13px;">{{ currencyFormatter(props.item.pendienteEntregar) }}</span>
                  </template>

             
                </v-data-table>
              </v-lazy>

              </v-card>
            </v-col>

          </v-row>


        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
        </v-card-actions>

      </v-card>
    </v-dialog>
    <!-------------------------------------------------------- fn Modal Producto Sugerido -->

    <!-- ------------------------------------------------------  Modal Loader -->

    <v-dialog v-model="Reparaloading" persistent width="300">
      <v-card color="grey darken-2" dark>
        <v-card-text>
          <br>
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- ------------------------------------------------------ fn Modal loader -->


    <!-- fn Modales -->


    <!--------------------------------------------------- tb add producto  -->
    <v-card>

      <v-toolbar flat dense color="#BDBDBD">

        <v-card-actions>


          <v-btn-toggle rounded dense>
            <v-tooltip top v-if="CelldAddProducto == true">
              <template v-slot:activator="{ on }">
                <!-- OpenAddProducto -->
                <v-btn v-on="on" v-show="!PropsInputDisabled" dark
                  @click.prevent="funcionValidaPermisoPv('AccBtnAgregarProductoTabla')" color="green">
                  <i style="font-size: 20px;" class="fa fa-plus-square"></i><!-- fab x-small dark  -->
                  Agregar Productos
                </v-btn>

              </template>
              <span>Agregar Productos</span>
            </v-tooltip>

            <!--CelldCrearProducto == true  (vieja)-->
            <v-tooltip v-if="false" top>
              <template v-slot:activator="{ on }">

                <v-btn v-on="on" dark color="#90A4AE" @click.prevent="dialogCrearProducto = !dialogCrearProducto">
                  <i style="font-size: 28px;" class="fa fa-file-o"> </i>
                  Crear Producto
                </v-btn>
              </template>
              <span>Crear Productos</span>
            </v-tooltip>

            <!-- Mostrar ventana para creacion de producto movil -->
            <v-tooltip v-if="showCrearProducto && hasPermisoCrearProducto()" top>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" dark color="#90A4AE"
                  @click.prevent="dialogCrearProductoMovil = !dialogCrearProductoMovil">
                  <i style="font-size: 28px;" class="fa fa-file-o"> </i>
                  Crear Producto Rapido
                </v-btn>
              </template>
              <span>Crear Productos Rapido</span>
            </v-tooltip>

          </v-btn-toggle>


        </v-card-actions>
        <v-spacer></v-spacer>
      <!-- dense single-line  class="pt-0 mt-0 fontSize12" style="border:1px solid #CFD8DC;" hide-details-->
        <!-- <v-card-actions> </v-card-actions> outlined -->
           <v-col  class="pa-0 ma-0 py-0 my-0 px-2" cols="2" md="3" sm="3">
                                      <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                          <v-text-field
                                            ref="RefTextFieldSearchBuscarProd"
                                            v-model="searchBuscarProd"
                                            autocomplete="off"
                                            class="fontSize13 black--text"
                                            color="black"
                                            dense outlined
                                            hide-details
                                            label="Buscar general"
                                            v-on="on"
                                          >
                                            <template v-slot:prepend-inner>
                                              <i class="fa fa-search" style="font-size: 25px"></i>
                                            </template>
                                          </v-text-field>
                                        </template>
                                        <span>Busqueda</span>
                                      </v-tooltip>
                                </v-col>     
        

            
        <!-- id="TbBord"   <v-toolbar-title class="font-weight-light"><v-card-title>FACTURAS INICIALES</v-card-title></v-toolbar-title> -->

      </v-toolbar>
      <v-data-table @current-items="PosicionFocus" class="elevation-1" id="TbBord" dense :headers="HeaderDate"
        :items="ListProd" item-key="indx" :footer-props="arrayPropiedases" @pagination="cargarPaginacionAll"
        :items-per-page="TbPaginator.itemsPerPage" :page.sync="TbPaginator.page" :pageCount="TbPaginator.pageCount"
        :loading="loaderTabla" :search="searchBuscarProd">

        <template v-slot:item.valor="props">
          <span v-if="PropsFacturaProveedor == true" style="display:none;">{{ props.item.indx =
            ListProd.indexOf(props.item) }}
            <!-- {{calcularImporte(props.item)}}   -->
          </span>

          <span v-if="PropsFacturaProveedor == false" style="display:none;">{{ props.item.indx =
            ListProd.indexOf(props.item)
            }}
            <!-- {{ props.item.valor = (props.item.cantidad *
            (props.item.costo + props.item.impuesto)) - calcularDescuento(props.item)
            }}  -->
          </span>

          <v-text-field v-if="PropsDecimalPlaces == 2" label="" id="formdisabledInput" 
            disabled   autocomplete="off" :value="currencyFormatter(props.item.valor)"
            dense single-line  class="pt-0 mt-0 fontSize12" style="font-size:13px; border:1px solid #CFD8DC;" hide-details>
          </v-text-field>

          <AutoNumericNuevoWithOptions v-if="PropsDecimalPlaces != 2" :options="{ decimalPlaces: PropsDecimalPlaces }"
            id="formdisabledInput" disabled label="" autocomplete="off" :value="props.item.valor"
            dense single-line  class="pt-0 mt-0 fontSize12" style="font-size:13px; border:1px solid #CFD8DC;" hide-details>
          </AutoNumericNuevoWithOptions>
        </template>


        <template v-slot:item.action="{ item }">


          <v-btn id="formdisabledInput" :disabled="PropsInputDisabled" v-if="btnEliminar == true" fab
            @click.prevent="eliminarItem(item)" x-small color="red darken-3"><i style="font-size: 20px;"
              class="fa fa-trash-o"></i></v-btn>

          <v-tooltip top v-if="btnVerAlm == true">
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" fab @click.prevent="VerOtroAlmacenItem(item)" x-small color="yellow accent-4"><i
                  style="font-size: 20px;" class="fa fa-eye"></i></v-btn>
            </template>
            <span>Ver otros Almacenes</span>
          </v-tooltip>

        </template>


        <template v-slot:item.factura="props">
          <!-- <span style="font-size:13px;" >{{props.item.producto.descripcion}} :value="props.item.factura"  </span> -->
          <v-text-field label="" id="formdisabledInput"  autocomplete="off" v-model.number="props.item.factura"
            @blur="props.item.noFactura = props.item.factura + ''"  @focus="focuFactura(props.item)"
            dense single-line  class="pt-0 mt-0 fontSize12" style="font-size:13px; border:1px solid #CFD8DC;" hide-details>
          </v-text-field>

        </template>


        <template v-slot:item.unidadProducto="props">
          <span v-if="props.item.unidadProducto != null && props.item.unidadProducto.hasOwnProperty('costo')"
            style="display:none;">{{ props.item.unidadProducto.codigoProducto =
            GetCodigoProdUni(props.item.unidadProducto) }}</span>
          <!--@focus=""@change="" @blur="" v-on:keydown="OnKeyupAddRowProduc(props.item)" @keyup="KeyupAddRowProducCombox"-->
          <v-combobox id="formdisabledInput" :disabled="PropsInputDisabled" :ref="'codigo' + props.item.indx" 
          v-model="props.item.unidadProducto" label="" autocomplete="off" :items="RproductoBuscados" item-text="codigoProducto"
            v-on:change="changeSelectProduc(props.item)" @blur="BlurTabSelectProduc(props.item)"
            @keyup="OnKeyDownProducCombox($event,'codigo',props.item.indx)"
            dense single-line  class="pt-0 mt-0 fontSize12" style="font-size:13px; border:1px solid #CFD8DC;" hide-details >
            <!--v-on:keyup.down="OnKeyupAddRowProducCombox(props.item)"-->

            <template v-slot:selection="{ attrs, item, parent, selected }">

              <span class="black--text"
                v-if="props.item.unidadProducto != null && !props.item.unidadProducto.hasOwnProperty('codigoProducto')">{{
                item
                }}</span>
              <span class="black--text"
                v-if="props.item.unidadProducto != null && props.item.unidadProducto.hasOwnProperty('codigoProducto')">{{
                item.codigoProducto
                }}</span>

            </template>

            <template slot="item" slot-scope="item" margin-top="50px">
              <span class="black--text"> {{ item.item.productos.descripcion }}-{{ item.item.unidades.descripcion }}
              </span>
            </template>

          </v-combobox>
        </template>
        <!--  || !props.item.producto.pedirNombre v-model="props.item.descripcion" -->
        <template v-slot:item.producto.descripcion="props">
          <span v-if="props.item.producto != null" style="display:none;">
            {{ props.item.propsDesProdUnid =props.item.producto.descripcion + " " + props.item.unidad.descripcion
            }}</span>

          <span
            v-if="props.item.producto != null && PropsOrdenCompra==true && !props.item.hasOwnProperty('descripcion') || 
            props.item.hasOwnProperty('descripcion') && props.item.descripcion!=null && props.item.descripcion.trim().length==0"
            style="display:none;">
            {{ props.item.descripcion =props.item.producto.descripcion.trim() + " " +
            props.item.unidad.descripcion.trim() }}</span>

          <v-text-field v-if="props.item.producto != null && PropsOrdenCompra==false" id="formdisabledInput"
            :disabled="PropsInputDisabled" label="" autocomplete="off" :value="props.item.propsDesProdUnid"
            @keyup="OnKeyDownProducCombox($event,'TextdescripProducto',props.item.indx)" :ref="'TextdescripProducto' + props.item.indx"
            dense single-line  class="pt-0 mt-0 fontSize12" style="font-size:13px; border:1px solid #CFD8DC;" hide-details>
          </v-text-field>

          <!-- :value="props.item.propsDesProdUnid" -->
          <v-text-field v-if="props.item.producto != null && PropsOrdenCompra==true" id="formdisabledInput"
            :disabled="VerificarPedirNombre(props.item)" label=""  autocomplete="off"  v-model="props.item.descripcion" 
            @keyup="OnKeyDownProducCombox($event,'TextdescripProducto',props.item.indx)" :ref="'TextdescripProducto' + props.item.indx"
            dense single-line  class="pt-0 mt-0 fontSize12" style="font-size:13px; border:1px solid #CFD8DC;" hide-details>
          </v-text-field>

          <!-- Sin producto (IA): mostrar limpia — se leyó la fila pero no hay match en BD -->
          <v-text-field
            v-if="props.item.producto == null && descripcionLimpiaFilaIa(props.item)"
            id="formdisabledInput"
            disabled
            label=""
            autocomplete="off"
            :value="descripcionLimpiaFilaIa(props.item)"
            :ref="'TextdescripProducto' + props.item.indx"
            dense single-line
            class="pt-0 mt-0 fontSize12"
            style="font-size:13px; border:1px solid #CFD8DC;"
            hide-details>
          </v-text-field>
        </template>
<template v-slot:item.loteFabricante="props">
<v-text-field  id="formdisabledInput"
            :disabled="PropsInputDisabled" label=""  autocomplete="off" v-model="props.item.loteFabricante" @blur="blurTextFielLoteFabricante(props.item)" 
            @keyup="OnKeyDownProducCombox($event,'TextloteFabricante',props.item.indx)"  :ref="'TextloteFabricante' + props.item.indx"
            dense single-line  class="pt-0 mt-0 fontSize12" style="font-size:13px; border:1px solid #CFD8DC;" hide-details>
          </v-text-field>
</template>

        <template v-slot:item.fechavencimiento="props">
          <v-text-field :disabled="fechaVencimientoControlVenc(props.item)"
            v-if="props.item.producto != null && PropsDevolucion" id="formdisabledInput"  type="date" label="" @blur="fechaVencimientoAVencer(props.item)"
            v-model="props.item.fechavencimiento" :ref="'fechavencimiento' + props.item.indx"
            dense single-line  class="pt-0 mt-0 fontSize12" style="font-size:13px; border:1px solid #CFD8DC;" hide-details>
          </v-text-field>
          <v-text-field v-if="props.item.producto != null && !PropsDevolucion" id="formdisabledInput" type="date" label="" 
          :disabled="!props.item.producto.controlVencimiento" @blur="fechaVencimientoAVencer(props.item)" v-model="props.item.fechavencimiento"
            :ref="'fechavencimiento' + props.item.indx"
            dense single-line  class="pt-0 mt-0 fontSize12" style="font-size:13px; border:1px solid #CFD8DC;" hide-details>
          </v-text-field>
        </template>


        <!--@input="calcularLineas(props.item)"  -->
        <template v-slot:item.cantidadpedida="props">
          <AutoNumeric label=""  id="formdisabledInput" disabled 
            autocomplete="off" v-model.number="props.item.cantidadpedida"
            dense single-line  class="pt-0 mt-0 fontSize12" style="font-size:13px; border:1px solid #CFD8DC;" hide-details>
          </AutoNumeric>
        </template>


        <!--@input="calcularLineas(props.item)" calcularImporte(props.item) -->
        <template v-slot:item.cantidad="props">
<!-- v-on:keydown.down="OnKeyupAddRowProducCombox(props.item)" -->
          <AutoNumeric v-if="PropsDecimalPlaces == 2" id="formdisabledInput" :disabled="PropsInputDisabled" label=""
            :ref="'cantidad' + props.item.indx" autocomplete="off"  v-model.number="props.item.cantidad" 
            @blur="calcularTotales" v-on:input="VerificarCantidad(props.item)" @input="calcularImporte(props.item)"
           @keydown="OnKeyDownProducCombox($event,'cantidad',props.item.indx)"
           v-on:blur="verifAddNewrow(props.item)"
           dense single-line  class="pt-0 mt-0 fontSize12" style="font-size:13px; border:1px solid #CFD8DC;" hide-details >
          </AutoNumeric>

          <AutoNumericNuevoWithOptions v-if="PropsDecimalPlaces != 2" :options="{ decimalPlaces: PropsDecimalPlaces }"
            id="formdisabledInput" :disabled="PropsInputDisabled" label=""  :ref="'cantidad' + props.item.indx" autocomplete="off"  v-model.number="props.item.cantidad" 
            @blur="calcularTotales" v-on:input="VerificarCantidad(props.item)" @input="calcularImporte(props.item)"
           @keydown="OnKeyDownProducCombox($event,'cantidad',props.item.indx)"
            v-on:blur="verifAddNewrow(props.item)"
            dense single-line  class="pt-0 mt-0 fontSize12" style="font-size:13px; border:1px solid #CFD8DC;" hide-details>
          </AutoNumericNuevoWithOptions>

        </template>

        <!-- @input="calcularLineas(props.item)" -->
        <!-- v-on:blur="calcularImporte(props.item)" -->
         <!-- v-on:keydown.down="OnKeyupAddRowProducCombox(props.item)" -->
        <template v-slot:item.costo="props">
          <AutoNumeric v-if="PropsDecimalPlaces == 2" label="" id="formdisabledInput" :disabled="DisableCosto"
            autocomplete="off" v-model.number="props.item.costo" @blur="calcularTotales" v-on:blur="blurCostoValidarPrecioCosto(props.item)" 
            v-on:input="setCostoPrecioAnteKeyinput(props.item)" :ref="'textcosto' + props.item.indx"  @keydown="OnKeyDownProducCombox($event,'textcosto',props.item.indx)"
            dense single-line  class="pt-0 mt-0 fontSize12" style="font-size:13px; border:1px solid #CFD8DC;" hide-details>
          </AutoNumeric>

          <AutoNumericNuevoWithOptions v-if="PropsDecimalPlaces != 2" :options="{ decimalPlaces: PropsDecimalPlaces }"
            label="" id="formdisabledInput" :disabled="DisableCosto" autocomplete="off" v-model.number="props.item.costo" @blur="calcularTotales"
            v-on:blur="blurCostoValidarPrecioCosto(props.item)" v-on:input="setCostoPrecioAnteKeyinput(props.item)"
           :ref="'textcosto' + props.item.indx"  @keydown="OnKeyDownProducCombox($event,'textcosto',props.item.indx)"
           dense single-line  class="pt-0 mt-0 fontSize12" style="font-size:13px; border:1px solid #CFD8DC;" hide-details>
          </AutoNumericNuevoWithOptions>

        </template>

        <template v-slot:item.itbis="props">
          <AutoNumeric label="" id="formdisabledInput" disabled  autocomplete="off" v-model.number="props.item.impuesto"
            dense single-line  class="pt-0 mt-0 fontSize12" style="font-size:13px; border:1px solid #CFD8DC;" hide-details>
          </AutoNumeric>
          <!-- <AutoNumeric label="" id="formdisabledInput" disabled style="font-size:13px;" dense hide-details outlined
            autocomplete="off" v-model.number="props.item.itbis">
          </AutoNumeric> -->
        </template>

        <!--@input="calcularLineas(props.item)" @input="calcularImporte(props.item)" -->
        <!--v-on:keydown.down="OnKeyupAddRowProducCombox(props.item)"  -->
        <template v-slot:item.impuesto="props">
          <AutoNumeric v-if="PropsDecimalPlaces == 2" id="formdisabledInput" :disabled="PropsInputDisabled" label=""
             autocomplete="off" v-model.number="props.item.impuesto" @blur="calcularTotales" v-on:blur="blurItbsImpuestoValidarCalculo(props.item)"
            :ref="'textimpuesto' + props.item.indx"  @keydown="OnKeyDownProducCombox($event,'textimpuesto',props.item.indx)" 
            dense single-line  class="pt-0 mt-0 fontSize12" style="font-size:13px; border:1px solid #CFD8DC;" hide-details>
          </AutoNumeric>

          <AutoNumericNuevoWithOptions v-if="PropsDecimalPlaces != 2" :options="{ decimalPlaces: PropsDecimalPlaces }"
            id="formdisabledInput" :disabled="PropsInputDisabled" label="" autocomplete="off" v-model.number="props.item.impuesto"
             @blur="calcularTotales" v-on:blur="blurItbsImpuestoValidarCalculo(props.item)"
           :ref="'textimpuesto' + props.item.indx"  @keydown="OnKeyDownProducCombox($event,'textimpuesto',props.item.indx)"
            dense single-line  class="pt-0 mt-0 fontSize12" style="font-size:13px; border:1px solid #CFD8DC;" hide-details >
          </AutoNumericNuevoWithOptions>
        </template>

        <template v-slot:item.existencia="props">
          <!-- <span>{{props.item.existencia}}</span> -->
          <v-text-field label="" id="formdisabledInput" disabled autocomplete="off" :value="props.item.existencia"
            dense single-line  class="pt-0 mt-0 fontSize12" style="font-size:13px; border:1px solid #CFD8DC;" hide-details>
          </v-text-field>
        </template>


        <template v-slot:item.oferta="props">
          <AutoNumeric label="" autocomplete="off"  v-model.number="props.item.oferta" @blur="calcularTotales,verifAddNewrow"
            dense single-line  class="pt-0 mt-0 fontSize12" style="font-size:13px; border:1px solid #CFD8DC;" hide-details>
          </AutoNumeric>
        </template>

        <template v-slot:item.ofertaSelect="props">

<!-- px-2 -->
          <v-checkbox  id="formdisabledInput" :disabled="PropsInputDisabled"  color="teal" label=""
            v-model="props.item.ofertaSelect" width="50" @change="isOferta(props.item)" 
            dense single-line  class="py-2 px-1 pt-0 mt-0 fontSize12" style="font-size:13px; border:1px solid #CFD8DC;" hide-details>
            <template v-slot:label>
              <strong v-if="props.item.ofertaSelect == true" style="color:#000000; font-size:13px;"> Si </strong>
              <strong v-if="props.item.ofertaSelect == false" style="color:#000000; font-size:13px;"> No </strong>
            </template>
          </v-checkbox>

        </template>



        <template v-slot:item.devolucion="props">
          <AutoNumeric label=""  :disabled="DisableDevolucion"
            autocomplete="off" v-model.number="props.item.devolucion" @blur="calcularTotales"
            dense single-line  class="pt-0 mt-0 fontSize12" style="font-size:13px; border:1px solid #CFD8DC;" hide-details>
          </AutoNumeric>
        </template>



        <template v-slot:item.venta="props">
          <span style="display:none;">{{ props.item.venta = props.item.hasOwnProperty("venta") && props.item.venta !=
            null ? props.item.venta : 0 }}</span>
          <AutoNumeric label="" disabled id="formdisabledInput" autocomplete="off" v-model.number="props.item.venta"
            dense single-line  class="pt-0 mt-0 fontSize12" style="font-size:13px; border:1px solid #CFD8DC;" hide-details>
          </AutoNumeric>
        </template>
        <!-- @input="calcularImporte(props.item)" -->
        <!-- v-on:blur="calcularImporte(props.item)" -->
        <template v-slot:item.precio="props">
          <AutoNumeric id="formdisabledInput" :disabled="PropsInputDisabled" label=""
            v-if="props.item.hasOwnProperty('precio') && PropsDecimalPlaces == 2" autocomplete="off" v-model.number="props.item.precio" @blur="calcularTotales"
            v-on:blur="blurPrecioValidarPrecioCosto(props.item)" v-on:input="props.item.precioAnte = props.item.precio"
           :ref="'textPrecio' + props.item.indx"  @keydown="OnKeyDownProducCombox($event,'textPrecio',props.item.indx)" 
            dense single-line  class="pt-0 mt-0 fontSize12" style="font-size:13px; border:1px solid #CFD8DC;" hide-details>
          </AutoNumeric>

          <AutoNumericNuevoWithOptions :options="{ decimalPlaces: PropsDecimalPlaces }" id="formdisabledInput"
            :disabled="PropsInputDisabled" label=""
            v-if="props.item.hasOwnProperty('precio') && PropsDecimalPlaces != 2" autocomplete="off" v-model.number="props.item.precio" @blur="calcularTotales"
            v-on:blur="blurPrecioValidarPrecioCosto(props.item)" v-on:input="props.item.precioAnte = props.item.precio"
           :ref="'textPrecio' + props.item.indx"  @keydown="OnKeyDownProducCombox($event,'textPrecio',props.item.indx)" 
           dense single-line  class="pt-0 mt-0 fontSize12" style="font-size:13px; border:1px solid #CFD8DC;" hide-details>
          </AutoNumericNuevoWithOptions>
        </template>


        <template v-slot:item.descuento="props">
          <AutoNumeric v-if="PropsDecimalPlaces == 2" id="formdisabledInput" :disabled="PropsInputDisabled" label=""
            autocomplete="off" v-model.number="props.item.descuento"
            @blur="calcularTotales" @input="calcularImporte(props.item)" :ref="'textDescuento' + props.item.indx"
            @keydown="OnKeyDownProducCombox($event,'textDescuento',props.item.indx)" 
            v-on:blur="getCrearCont"
            dense single-line  class="pt-0 mt-0 fontSize12" style="font-size:13px; border:1px solid #CFD8DC;" hide-details>
          </AutoNumeric>

          <AutoNumericNuevoWithOptions v-if="PropsDecimalPlaces != 2" :options="{ decimalPlaces: PropsDecimalPlaces }"
            id="formdisabledInput" :disabled="PropsInputDisabled" label="" autocomplete="off" v-model.number="props.item.descuento" @blur="calcularTotales"
            @input="calcularImporte(props.item)"  :ref="'textDescuento' + props.item.indx"
            @keydown="OnKeyDownProducCombox($event,'textDescuento',props.item.indx)" v-on:blur="getCrearCont"
            dense single-line  class="pt-0 mt-0 fontSize12" style="font-size:13px; border:1px solid #CFD8DC;" hide-details>
          </AutoNumericNuevoWithOptions>
        </template>

        <template v-slot:item.descuentoPorciento="props">
          <!-- <span>{{currencyFormatter(props.item.descuentoPorciento)}}</span> class="mt-0"    -->

          <!-- @change="calcularTotales" -->
          <v-switch @change="getCrearCont" id="formdisabledInput" :disabled="PropsInputDisabled" v-model="props.item.descuentoPorciento"
            label="Activo" color="success" v-on:change="calcularImporte(props.item)"
            dense single-line  class="py-2 px-1 pt-0 mt-0 fontSize12" style="font-size:13px; border:1px solid #CFD8DC;" hide-details>

            <template v-slot:label>
              <strong v-if="props.item.descuentoPorciento == true" style="color:#000000; font-size: 13px; "> % </strong>
              <strong v-if="props.item.descuentoPorciento == false" style="color:#000000; font-size: 13px; "> $
              </strong>
            </template>

          </v-switch>


        </template>


        <template v-slot:item.almacen="props">
          <v-combobox id="formdisabledInput" :disabled="PropsInputDisabled" :ref="'Almacen' + props.item.indx"
             autocomplete="off" label="" :items="Ralmacen" item-text="descripcion" v-model="props.item.almacen" @focus="CargarRalmacen"
            dense single-line  class="pt-0 mt-0 fontSize12" style="font-size:13px; border:1px solid #CFD8DC;" hide-details>
            <template v-slot:selection="{ attrs, item, parent, selected }">
              <span class="black--text" v-if="item.hasOwnProperty('descripcion')">{{ item.descripcion.trim() }}</span>
            </template>
          </v-combobox>
        </template>

        <template v-slot:body.append v-if="windowSize.width > 600">
          <tr>
            <td class="border-top-bottom"><strong>Cantidad:{{ ListProd.length }}</strong></td>
            <td class="border-top-bottom" v-if="CelldFactura == true"><strong></strong></td>
           <td class="border-top-bottom" v-if="CelldAlmacen == true"><strong></strong></td>
            <td class="border-top-bottom" v-if="CelldloteFabricante == true"><strong></strong></td>
           <td class="border-top-bottom"><strong class="d-flex justify-end"
                style="font-size:15px; color: #00838F;">Total:</strong></td>
            <td class="border-total" v-if="CelldFechav == true"><strong class="d-flex justify-center"
                style="font-size:15px; color: #00838F;"> </strong></td>

            <td class="border-total" v-if="CellCantpedida == true"><strong class="d-flex justify-center"
                style="font-size:15px; color: #00838F;"> </strong></td>
            <td class="border-total"><strong class="d-flex justify-center" style="font-size:15px; color: #00838F;">
              </strong></td>
            <td class="border-top-bottom" v-if="CelldOferta == true"><strong></strong></td>
            <td class="border-total" v-if="CelldExistenc == true"><strong class="d-flex justify-center"
                style="font-size:15px; color: #00838F;"> </strong></td>
            <td class="border-top-bottom" v-if="CelldOfertaSelect == true"><strong></strong></td>
            <td class="border-total" v-if="CelldVenta == true"><strong class="d-flex justify-center"
                style="font-size:15px; color: #00838F;"> </strong></td>
            <td class="border-total" v-if="Celldprecio == true"><strong class="d-flex justify-center"
                style="font-size:15px; color: #00838F;"> </strong></td>
            <td class="border-top-bottom"><strong></strong></td>
            <td class="border-top-bottom" v-if="CelldItbis == true"><strong></strong></td>
            <td class="border-total" v-if="CelldImpuesto == true"><strong class="d-flex justify-center"
                style="font-size:15px; color: #00838F;">
                <!-- {{ RedondeoValorCantRed(TotalProd.impuesto,PropsDecimalPlaces ) }}  -->
                {{ currencyFormatterCant(TotalProd.impuesto, PropsDecimalPlaces) }}
              </strong></td>
            <td class="border-total" v-if="CelldDescuento == true"><strong class="d-flex justify-center"
                style="font-size:15px; color: #00838F;">
                <!-- {{ RedondeoValorCantRed(TotalProd.descuento,PropsDecimalPlaces )  }}  -->
                {{ currencyFormatterCant(TotalProd.descuento, PropsDecimalPlaces) }}
              </strong></td>
            <td class="border-top-bottom" v-if="CelldDesPociento == true"><strong></strong></td>
            <td class="border-top-bottom" v-if="CelldDevolucion == true"><strong></strong></td>
            <td class="border-total" v-if="CelldImporte == true"><strong class="d-flex justify-center"
                style="font-size:15px; color: #00838F;">
                <!-- {{ RedondeoValorCantRed(TotalProd.importe,PropsDecimalPlaces )  }}  -->
                {{ currencyFormatterCant(TotalProd.importe, PropsDecimalPlaces) }}

              </strong></td>

            <!-- <td class="border-total" ><strong class="d-flex justify-center" style="font-size:15px; color: #00838F;"> {{currencyFormatter(form.Total.Total)}} </strong></td> -->
            <td class="border-top-bottom"><strong></strong></td>
          </tr>
        </template>

        <template v-slot:footer v-if="windowSize.width <= 600">
          <v-list-item style="font-size: 70%;" class="white--text">
            <v-list-item-content>
              <span></span>
              <span></span>
              <!-- currencyFormatter -->
              <span> DESCUENTO: {{ currencyFormatterCant(TotalProd.descuento, PropsDecimalPlaces) }}</span>
              <span>IMPUESTO: {{ currencyFormatterCant(TotalProd.impuesto, PropsDecimalPlaces) }} </span>
              <span>IMPORTE: {{ currencyFormatterCant(TotalProd.importe, PropsDecimalPlaces) }}</span>

            </v-list-item-content>
          </v-list-item>

        </template>
      </v-data-table>
    </v-card>
    <!--------------------------------------------------- fn tb add producot -->

    <!---------------------  Panel Menu Opcion Botones ------------------------------->
    <div style="max-height:300px;" class="overflow-x-auto" v-show="false">
      <!-- columna  ---------------------->
      <PvMenuOpcionBotones ref="RefPvMenuOpcionBotones" @DataRetornAccion="DataRetornMenuOpcBotonesPermisosPv"
        @DataRetornAccionPadre="DataRetornPadrePermisoPv" />
    </div>
    </div>


  </v-col>

</template>
<script>
import { EventBus } from "../../event-bus";
import AutoNumeric from "../../components/AutoNumericNuevo";
import AutoNumericNuevoWithOptions from "../../components/AutoNumericNuevoWithOptions.vue";
import AgregarProducto from "../../CuentaXPagar/UtilidadComponents/AgregarProducto";
import AgregarProductoDistFarma from "../../CuentaXPagar/UtilidadComponents/AgregarProductoDistFarma.vue";
import CrearProducto from "../../CuentaXPagar/UtilidadComponents/CrearProducto";
import CrearDocumento from "../../Inventario/UtilidadComponents/CrearDocumento";
import { currencyFormatter, FormatoFecha, HoraFormatter, RedondeoValorCantRed, currencyFormatterCant } from "@/js/Funciones.js";
import PvMenuOpcionBotones from "@/PuntodeVenta/UtilidadComponents/PvMenuOpcionBotones.vue";
import ImprimirEtiquetasComponet from "../../Inventario/UtilidadComponents/ImprimirEtiquetas";
import CreacionProductoMovil from "../../Inventario/Mant/CreacionProductoMovil";
import dirkeydown from "@/directives/dir-keydown"
export default {
directives: {
      dirkeydown,
    },
  components: {
    AutoNumeric,
    CrearProducto,
    CrearDocumento,
    AgregarProducto,
    ImprimirEtiquetasComponet,
    AutoNumericNuevoWithOptions,
    PvMenuOpcionBotones,
    CreacionProductoMovil,
    AgregarProductoDistFarma
  },

  mounted() {
    this.onResize()
    // EventBus.$on("onResize", this.onResize);
    this.CrearHeader()
    console.log(this.PropsDecimalPlaces)

  },
  data: () => ({
    isActive:false,
    arrayPropiedases: {
      'items-per-page-options': [10, 15, 20, 50],
      'items-per-page-text': 'Cantidad de Registros Por Paginas',
      showFirstLastPage: true
    },

    searchBuscarProd:"",
    TbPaginator: {
      itemsLength: 0,
      itemsPerPage: 15,
      page: 1,
      pageCount: 0,
      pageStart: 0,
      pageStop: 0
    },
    loaderTabla: false,
    windowSize: { width: "auto", height: "auto" },
    valid: true,
    dialogCrearProducto: false,
    dialogCrearProductoMovil: false,
    dialogAddProducto: false,

    VarKeyCode: 0,
    RproductoBuscados: [],
    Ralmacen: [],
    Rproducto: [],

      lote:0,

    aalert: {
      estado: false,
      color: null,
      type: ""

    },

    dialogVerOtroAlmacen: false,
    OtroAlmacen: null,
    impuestoincluido: false,
    descuentoIndividual: 0,
    TotalProd: { cantidad: 0, cantExit: 0, costo: 0, impuesto: 0, descuento: 0, importe: 0 },
    HeaderDate: [],
    sugerencia: [],
    Reparaloading: false,
    FacturaTemporal: null,

    DisableCosto: false,
    DisableDevolucion: false,
    btnVerAlm: true,
    btnEliminar: true,

    CelldCrearProducto: false,
    CelldAddProducto: false,

    CelldFechav: false,
    CellCantpedida: false,
    CelldVenta: false,
    CelldAlmacen: false,
    CelldImpuesto: false,
    CelldImporte: true,
    CelldExistenc: true,
    Celldprecio: false,
    CelldDescuento: true,
    CelldDesPociento: true,

    CelldCantSuger: true,
    CelldOferta: true,
    CelldOfertaSelect: true,
    CelldDevolucion: true,
    CelldFactura: true,
    CelldloteFabricante:false,

    AnchoCodigo: 150,
    AnchosValores: 120,
    AnchoCantidades: 90,
    AnchoAccion: 50,
    AnchoFecha: 80,
    AnchoAlmacen: 160
  }),

  props: {

    Fecdesde: {
      required: false,
      type: String
    },
    Fechasta: {
      required: false,
      type: String
    },
    ListProd: {
      required: true,
      type: Array

    },
    EntradaAlmacen: {
      required: false,
      type: Object
    },
    PropsDevolucion: {
      required: false,
      type: Boolean,
      default: false
    },
    PropsInputDisabled: {
      required: false,
      type: Boolean,
      default: false
    },
    PropsFacturaProveedor: {
      required: false,
      type: Boolean,
      default: false
    },
    PropsComprasSugeridas: {
      required: false,
      type: Boolean,
      default: false
    },
    PropsOrdenCompra: {
      required: false,
      type: Boolean,
      default: false
    },
    PropsDefault: {
      required: false,
      type: Boolean,
      default: false
    },
    ProsActuAlmacen: {
      required: false,
      type: Boolean,
      default: false
    },
    PropsUnidadminima: {
      required: false,
      type: Boolean,
      default: false
    },
    PropsDecimalPlaces: {
      required: false,
      type: Number,
      default: 2
    },
    showCrearProducto: {
      required: false,
      type: Boolean,
      default: false
    },
    // En carga IA: true evita newDetalle() al vaciar ListProd (fila 1 vacía).
    omitirFilaVaciaAutomatica: {
      required: false,
      type: Boolean,
      default: false
    },
  },

  methods: {
    currencyFormatter, FormatoFecha, HoraFormatter, RedondeoValorCantRed, currencyFormatterCant,

    onResize(e) {
      var jsn = { width: window.innerWidth, height: window.innerHeight - 112 }
      this.windowSize = jsn
    },
    OpenAddProducto() {
      this.dialogAddProducto = true

      var _this = this;
      setTimeout(function () {
        _this.$refs.RefAgregarProducto.CargarRproducto()
      }, 200);
    },

    CrearHeader() {
      var BOOL_LoFAB= this.$store.getters.GetConfiguracionGeneral.configInv.hasOwnProperty('usarLoteFabricante') && this.$store.getters.GetConfiguracionGeneral.configInv.usarLoteFabricante!=null? this.$store.getters.GetConfiguracionGeneral.configInv.usarLoteFabricante:false
      //---------------------------------Devolucion-------------------------------------------
      if (this.PropsDevolucion == true) {
        this.HeaderDate = [
          { text: 'FACTURA', value: 'factura', width: this.AnchosValores, sortable: false, class: ['no-gutters  black--text'] },
          { text: 'CÓDIGO', value: 'unidadProducto', width: this.AnchoCodigo, sortable: false, class: ['no-gutters black--text'] },
          { text: 'PRODUCTO', value: 'producto.descripcion', width: 'auto', sortable: false, class: ['no-gutters  black--text'] },
          { text: 'ALMACEN', value: 'almacen', width: this.AnchoAlmacen, sortable: false, class: ['px-3 no-gutters black--text'] },
          { text: 'FECHA V.', value: 'fechavencimiento', width: this.AnchoFecha, sortable: false, class: ['no-gutters black--text'] },
          // { text: 'CANT.PEDIDA', value: 'cantidadpedida', width:this.AnchoCantidades,sortable:false,class: ['no-gutters black--text']},
          { text: 'CANTIDAD', value: 'cantidad', width: this.AnchoCantidades, sortable: false, class: ['no-gutters black--text'] },
          //{ text: 'OFERTA', value: 'oferta',width:this.AnchoCantidades,sortable:false, class: ['px-3 no-gutters black--text'] },
          //{ text: 'EXISTENCIA', value: 'existencia',width:this.AnchoCantidades,sortable:false,class: ['no-gutters black--text']},
          // { text: 'OFERTA', value: 'ofertaSelect',width:this.AnchoCantidades,sortable:false, class: ['px-3 no-gutters black--text'] },
          //{ text: 'VENTAS', value: 'venta', width:this.AnchoCantidades,sortable:false, class: ['no-gutters black--text']},
          //{ text: 'PRECIO FAC.', value: 'precio', width:this.AnchoCantidades,sortable:false, class: ['no-gutters black--text']},
          { text: 'COSTO', value: 'costo', width: this.AnchosValores, sortable: false, class: ['no-gutters black--text'] },
          { text: 'ITBIS', value: 'itbis', width: this.AnchosValores, sortable: false, class: ['no-gutters black--text'] },
          // { text: 'ITBIS', value: 'impuesto', width: this.AnchosValores, sortable: false, class: ['no-gutters black--text'] },
          // { text: 'IMPUESTO', value: 'impuesto', width:this.AnchosValores,sortable:false, class: ['no-gutters black--text']},
          //{ text: 'DESCUENTO', value: 'descuento', width:this.AnchosValores,sortable:false, class: ['no-gutters black--text']},
          //{ text: '$ / %', value: 'descuentoPorciento',sortable:false, class: ['no-gutters black--text']},
          { text: 'IMPORTE', value: 'valor', width: this.AnchosValores, sortable: false, class: ['no-gutters black--text'] },
          //{ text: 'DEVOLUCIÓN', value: 'devolucion',width:this.AnchosValores,sortable:false, class: ['no-gutters black--text']},
          { text: 'ACCIÓN', value: 'action', width: 70, sortable: false, class: ['no-gutters black--text'] }
        ]

        
 if (BOOL_LoFAB) {
var newRow={ text: 'LOTE', value: 'loteFabricante', width: this.AnchosValores, sortable: false, class: ['no-gutters black--text'] };
  this.HeaderDate.splice(3, 0, newRow);
  this.CelldloteFabricante=true
}

        this.CelldCrearProducto = false
        this.CelldAddProducto = true
        this.CelldFechav = false
        this.CellCantpedida = false
        this.CelldVenta = true
        this.CelldAlmacen = true
        this.CelldImpuesto = false
        this.Celldprecio = false
        this.CelldDescuento = false
        this.CelldDesPociento = false
        this.CelldOferta = false
        this.CelldDevolucion = false
        this.CelldFactura = true
        this.CelldItbis = true
        this.CelldImporte = true
        this.CelldExistenc = false
        this.CelldOfertaSelect = false

        this.btnVerAlm = false
        this.btnEliminar = true
      }

      //--------------------------------- FacturaProveedor -------------------------------------------
      if (this.PropsFacturaProveedor == true) {
        
        this.HeaderDate = [
          //  { text: 'FACTURA', value: 'factura',width:this.AnchosValores,sortable:false,class: ['no-gutters  black--text']},
          { text: 'CÓDIGO', value: 'unidadProducto', width: this.AnchoCodigo, sortable: false, class: ['no-gutters black--text'] },
          { text: 'PRODUCTO', value: 'producto.descripcion', width: 'auto', sortable: false, class: ['no-gutters  black--text'] },
          
          { text: 'ALMACEN', value: 'almacen', width: this.AnchoAlmacen, sortable: false, class: ['px-3 no-gutters black--text'] },
          { text: 'FECHA V.', value: 'fechavencimiento', width: this.AnchoFecha, sortable: false, class: ['no-gutters black--text'] },
          // { text: 'CANT.PEDIDA', value: 'cantidadpedida', width:this.AnchoCantidades,sortable:false,class: ['no-gutters black--text']},
          { text: 'CANTIDAD', value: 'cantidad', width: this.AnchoCantidades, sortable: false, class: ['no-gutters black--text'] },
          // { text: 'OFERTA', value: 'oferta',width:this.AnchoCantidades,sortable:false, class: ['px-3 no-gutters black--text']},
          //{ text: 'EXISTENCIA', value: 'existencia',width:this.AnchoCantidades,sortable:false,class: ['no-gutters black--text']},
          { text: 'OFERTA', value: 'ofertaSelect', width: this.AnchoAccion, sortable: false, class: ['px-3 no-gutters black--text'] },
          // { text: 'VENTAS', value: 'venta', width:this.AnchoCantidades,sortable:false, class: ['no-gutters black--text']},
          { text: 'PRECIO FAC.', value: 'precio', width: this.AnchoCantidades, sortable: false, class: ['no-gutters black--text'] },
          { text: 'COSTO', value: 'costo', width: this.AnchosValores, sortable: false, class: ['no-gutters black--text'] },
          // { text: 'ITBIS', value: 'itbis', width:this.AnchosValores,sortable:false, class: ['no-gutters black--text']},
          { text: 'IMPUESTO', value: 'impuesto', width: this.AnchosValores, sortable: false, class: ['no-gutters black--text'] },
          { text: 'DESCUENTO', value: 'descuento', width: this.AnchosValores, sortable: false, class: ['no-gutters black--text'] },
          { text: '$ / %', value: 'descuentoPorciento', width: 90, sortable: false, class: ['no-gutters black--text'] },
          //  { text: 'DEVOLUCIÓN', value: 'devolucion',width:this.AnchosValores,sortable:false, class: ['no-gutters black--text']},
          { text: 'IMPORTE', value: 'valor', width: this.AnchosValores, sortable: false, class: ['no-gutters black--text'] },
          { text: 'ACCIÓN', value: 'action', width: 70, sortable: false, class: ['no-gutters black--text'] }
        ]
  

 if (BOOL_LoFAB) {
var newRow={ text: 'LOTE', value: 'loteFabricante', width: this.AnchosValores, sortable: false, class: ['no-gutters black--text'] };
  this.HeaderDate.splice(2, 0, newRow);
  this.CelldloteFabricante=true
}

        this.CelldCrearProducto = false
        this.CelldAddProducto = true
        this.CelldFechav = true
        this.CellCantpedida = false
        this.CelldVenta = false
        this.CelldAlmacen = true
        this.CelldImpuesto = true
        this.Celldprecio = true
        this.CelldDescuento = true
        this.CelldDesPociento = true
        this.CelldOferta = false
        this.CelldDevolucion = false
        this.CelldFactura = false
        this.CelldItbis = false
        this.CelldImporte = true
        this.CelldExistenc = false
        this.CelldOfertaSelect = true

        this.btnVerAlm = false
        this.btnEliminar = true
      }

      //--------------------------------- ComprasSugeridas-------------------------------------------
      if (this.PropsComprasSugeridas == true) {
        this.HeaderDate = [
          // { text: 'FACTURA', value: 'factura',width:this.AnchosValores,sortable:false,class: ['no-gutters  black--text']},
          { text: 'CÓDIGO', value: 'unidadProducto', width: this.AnchoCodigo, sortable: false, class: ['no-gutters black--text'] },
          { text: 'PRODUCTO', value: 'producto.descripcion', width: 'auto', sortable: false, class: ['no-gutters  black--text'] },
          // { text: 'ALMACEN', value: 'almacen', width:this.AnchoAlmacen,sortable:false, class: ['px-3 no-gutters black--text']},
          // { text: 'FECHA V.', value: 'fechavencimiento',width:this.AnchoFecha,sortable:false, class: ['no-gutters black--text']},
          // { text: 'CANT.PEDIDA', value: 'cantidadpedida', width:this.AnchoCantidades,sortable:false,class: ['no-gutters black--text']},
          { text: 'CANT.SUGERIDA', value: 'cantidad', width: this.AnchoCantidades, sortable: false, class: ['no-gutters black--text'] },
          { text: 'OFERTA', value: 'oferta', width: this.AnchoCantidades, sortable: false, class: ['px-3 no-gutters black--text'] },
          { text: 'EXISTENCIA', value: 'existencia', width: this.AnchoCantidades, sortable: false, class: ['px-3 no-gutters black--text'] },
          //{ text: 'OFERTA', value: 'ofertaSelect',width:this.AnchoAccion,sortable:false, class: ['px-3 no-gutters black--text']},
          { text: 'VENTAS', value: 'venta', width: this.AnchoCantidades, sortable: false, class: ['no-gutters black--text'] },
          // { text: 'PRECIO FAC.', value: 'precio', width:this.AnchoCantidades,sortable:false, class: ['no-gutters black--text']},
          { text: 'COSTO', value: 'costo', width: this.AnchosValores, sortable: false, class: ['no-gutters black--text'] },
          // { text: 'ITBIS', value: 'itbis', width:this.AnchosValores,sortable:false, class: ['no-gutters black--text']},
          //{ text: 'IMPUESTO', value: 'impuesto', width:this.AnchosValores,sortable:false, class: ['no-gutters black--text']},
          //{ text: 'DESCUENTO', value: 'descuento', width:this.AnchosValores,sortable:false, class: ['no-gutters black--text']},
          //{ text: '$ / %', value: 'descuentoPorciento',sortable:false, class: ['no-gutters black--text']},
          { text: 'DEVOLUCIÓN', value: 'devolucion', width: this.AnchosValores, sortable: false, class: ['no-gutters black--text'] },
          // { text: 'IMPORTE', value: 'valor', width:this.AnchosValores,sortable:false, class: ['no-gutters black--text']},
          { text: 'ACCIÓN', value: 'action', width: 70, sortable: false, class: ['no-gutters black--text'] }
        ]

        this.CelldCrearProducto = false
        this.CelldAddProducto = true
        this.CelldFechav = false
        this.CellCantpedida = false
        this.CelldVenta = true
        this.CelldAlmacen = false
        this.CelldImpuesto = false
        this.Celldprecio = false
        this.CelldDescuento = false
        this.CelldDesPociento = false
        this.CelldOferta = true
        this.CelldDevolucion = true
        this.CelldFactura = false
        this.CelldItbis = false
        this.CelldImporte = false
        this.CelldExistenc = true
        this.CelldOfertaSelect = false
        this.DisableCosto = true
        this.DisableDevolucion = true
        this.btnVerAlm = true
        this.btnEliminar = false
      }

      //---------------------------------Orden Compra-------------------------------------------
      if (this.PropsOrdenCompra == true) {
        this.HeaderDate = [
          // { text: 'FACTURA', value: 'factura',width:this.AnchosValores,sortable:false,class: ['no-gutters  black--text']},
          { text: 'CÓDIGO', value: 'unidadProducto', width: this.AnchoCodigo, sortable: false, class: ['no-gutters black--text'] },
          { text: 'PRODUCTO', value: 'producto.descripcion', width: 'auto', sortable: false, class: ['no-gutters  black--text'] },
          // { text: 'ALMACEN', value: 'almacen', width:this.AnchoAlmacen,sortable:false, class: ['px-3 no-gutters black--text']},
          //{ text: 'FECHA V.', value: 'fechavencimiento',width:this.AnchoFecha,sortable:false, class: ['no-gutters black--text']},
          //{ text: 'CANT.PEDIDA', value: 'cantidadpedida', width:this.AnchoCantidades,sortable:false,class: ['no-gutters black--text']},
          { text: 'CANTIDAD', value: 'cantidad', width: this.AnchoCantidades, sortable: false, class: ['no-gutters black--text'] },
          // { text: 'OFERTA', value: 'oferta',width:this.AnchoCantidades,sortable:false, class: ['px-3, no-gutters black--text'] },
          { text: 'EXISTENCIA', value: 'existencia', width: this.AnchoCantidades, sortable: false, class: ['no-gutters black--text'] },
          { text: 'OFERTA', value: 'ofertaSelect', width: this.AnchoAccion, sortable: false, class: ['px-3 no-gutters black--text'] },
          //{ text: 'VENTAS', value: 'venta', width:this.AnchoCantidades,sortable:false, class: ['no-gutters black--text']},
          // { text: 'PRECIO FAC.', value: 'precio', width:this.AnchoCantidades,sortable:false, class: ['no-gutters black--text']},
          { text: 'COSTO', value: 'costo', width: this.AnchosValores, sortable: false, class: ['no-gutters black--text'] },
          //{ text: 'ITBIS', value: 'itbis', width:this.AnchosValores,sortable:false, class: ['no-gutters black--text']},
          { text: 'IMPUESTO', value: 'impuesto', width: this.AnchosValores, sortable: false, class: ['no-gutters black--text'] },
          { text: 'DESCUENTO', value: 'descuento', width: this.AnchosValores, sortable: false, class: ['no-gutters black--text'] },
          { text: '$ / %', value: 'descuentoPorciento', width: this.AnchoAccion + 10, sortable: false, class: ['no-gutters black--text'] },
          //{ text: 'DEVOLUCIÓN', value: 'devolucion',width:this.AnchosValores,sortable:false, class: ['no-gutters black--text']},
          { text: 'IMPORTE', value: 'valor', width: this.AnchosValores, sortable: false, class: ['no-gutters black--text'] },
          { text: 'ACCIÓN', value: 'action', width: 70, sortable: false, class: ['no-gutters black--text'] }
        ]
        this.CelldCrearProducto = true
        this.CelldAddProducto = true
        this.CelldFechav = false
        this.CellCantpedida = true
        this.CelldVenta = false
        this.CelldAlmacen = false
        this.CelldImpuesto = true
        this.Celldprecio = false
        this.CelldDescuento = true
        this.CelldDesPociento = true
        this.CelldOferta = false
        this.CelldDevolucion = false
        this.CelldFactura = false
        this.CelldItbis = false
        this.CelldImporte = true
        this.CelldExistenc = true
        this.CelldOfertaSelect = false
        this.btnVerAlm = false
        this.btnEliminar = true
      }

      // Cantidad Despachada
      //---------------------------------Default-------------------------------------------
      if (this.PropsDefault == true) {
        this.HeaderDate = [
          { text: 'FACTURA', value: 'factura', width: this.AnchosValores, sortable: false, class: ['no-gutters  black--text'] },
          { text: 'CÓDIGO', value: 'unidadProducto', width: this.AnchoCodigo, sortable: false, class: ['no-gutters black--text'] },
          { text: 'PRODUCTO', value: 'producto.descripcion', width: 'auto', sortable: false, class: ['no-gutters  black--text'] },
          { text: 'ALMACEN', value: 'almacen', width: this.AnchoAlmacen, sortable: false, class: ['px-3 no-gutters black--text'] },
          { text: 'FECHA V.', value: 'fechavencimiento', width: this.AnchoFecha, sortable: false, class: ['no-gutters black--text'] },
          { text: 'CANT.PEDIDA', value: 'cantidadpedida', width: this.AnchoCantidades, sortable: false, class: ['no-gutters black--text'] },
          { text: 'CANTIDAD', value: 'cantidad', width: this.AnchoCantidades, sortable: false, class: ['no-gutters black--text'] },
          { text: 'OFERTA', value: 'oferta', width: this.AnchoCantidades, sortable: false, class: ['px-3 no-gutters black--text'] },
          { text: 'EXISTENCIA', value: 'existencia', width: this.AnchoCantidades, sortable: false, class: ['no-gutters black--text'] },
          { text: 'OFERTA', value: 'ofertaSelect', width: this.AnchoAccion, sortable: false, class: ['px-3 no-gutters black--text'] },
          { text: 'VENTAS', value: 'venta', width: this.AnchoCantidades, sortable: false, class: ['no-gutters black--text'] },
          { text: 'PRECIO FAC.', value: 'precio', width: this.AnchoCantidades, sortable: false, class: ['no-gutters black--text'] },
          { text: 'COSTO', value: 'costo', width: this.AnchosValores, sortable: false, class: ['no-gutters black--text'] },
          { text: 'ITBIS', value: 'itbis', width: this.AnchosValores, sortable: false, class: ['no-gutters black--text'] },
          { text: 'IMPUESTO', value: 'impuesto', width: this.AnchosValores, sortable: false, class: ['no-gutters black--text'] },
          { text: 'DESCUENTO', value: 'descuento', width: this.AnchosValores, sortable: false, class: ['no-gutters black--text'] },
          { text: '$ / %', value: 'descuentoPorciento', sortable: false, class: ['no-gutters black--text'] },
          { text: 'DEVOLUCIÓN', value: 'devolucion', width: this.AnchosValores, sortable: false, class: ['no-gutters black--text'] },
          { text: 'IMPORTE', value: 'valor', width: this.AnchosValores, sortable: false, class: ['no-gutters black--text'] },
          { text: 'ACCIÓN', value: 'action', width: 70, sortable: false, class: ['no-gutters black--text'] }
        ]

        this.CelldCrearProducto = true
        this.CelldAddProducto = true
        this.CelldFechav = true
        this.CellCantpedida = true
        this.CelldVenta = true
        this.CelldAlmacen = true
        this.CelldImpuesto = true
        this.Celldprecio = true
        this.CelldDescuento = true
        this.CelldDesPociento = true
        this.CelldOferta = true
        this.CelldDevolucion = true
        this.CelldFactura = true
        this.CelldItbis = true
        this.CelldImporte = true
        this.CelldExistenc = true
        this.CelldOfertaSelect = true
        this.btnVerAlm = true
        this.btnEliminar = true
      }
    },

    CargarRalmacen() {
      this.$axios
        .get(this.$hostname + this.$hName + "/almacen",
          { headers: this.$store.getters.GetheadersAxios })
        .then(res => {
          this.Ralmacen = res.data;
        });
    },

    GetCodigoProdUni(unidaproducto) {
      var pk = unidaproducto.unidadesProductosPK;
      var codigoP = ('000000' + pk.producto).substring(('000000' + pk.producto).length - 6, ('000000' + pk.producto).length)
      var codigoU = ('0000' + pk.unidad).substring(('0000' + pk.unidad).length - 4, ('0000' + pk.unidad).length)
      var codigoLote = "";

        if(unidaproducto.lote==null || unidaproducto.lote!=null &&  (""+unidaproducto.lote).trim().length== 0){
          unidaproducto.lote=0
        }

        if(unidaproducto.lote!=null&&typeof unidaproducto.lote === "string" && unidaproducto.lote.trim().length > 0){
            unidaproducto.lote = parseInt(unidaproducto.lote)
          }

      if (this.$store.getters.GetConfiguracionGeneral.configInv.usarLote) {
        if (unidaproducto.lote !== "") {
          // codigoLote = unidaproducto.lote
          codigoLote = ('0000' + unidaproducto.lote).substring(('0000' + unidaproducto.lote).length - 4, ('0000' + unidaproducto.lote).length)
              
        }
      }

      var codigoBarra = codigoP + codigoU + codigoLote;
      if (this.$store.getters.GetConfiguracionGeneral.configInv.usarLote && codigoBarra.length > 14) {
        codigoBarra = codigoBarra.substring(0, 14)
      }
      return codigoBarra
    },
    fechaVencimientoAVencer(t) {


      //NOTA :LIMITAR Año a 4 DIGITO
       if(t.fechavencimiento!=null && t.fechavencimiento.length>10){
        var FECHASPLI=t.fechavencimiento.split('-')
        var NEWFCH=`${FECHASPLI[0].substr(0,4)}-${FECHASPLI[1]}-${FECHASPLI[2]}`
        t.fechavencimiento=NEWFCH
       }

      if (this.$store.getters.GetConfiguracionGeneral.configInv.usarLote) {
        if (t.fechavencimiento != null && t.fechavencimiento.length > 0) {
          this.$axios
            .get(
              this.$hostname + this.$hName + "/fechaVencimiento/findByFecha/" + t.fechavencimiento.trim().substr(0, 10) + "T04:00",
              { headers: this.$store.getters.GetheadersAxios }
            )
            .then((res) => {
              t.fechavencimiento = res.data.fechaInicial
              t.lote = res.data.codigo
              var e = new Date(), d = new Date(t.fechavencimiento)
              e.setMonth(e.getMonth() + 3)
              var hoy =new Date();
              if(d<hoy){
                this.alerta("Este producto esta vencido", "error")
                return
              }

              if (d < e) {
                this.alerta("Este producto esta próximo a vencerse", "error")
                return
              }


            })
            .catch(error => {
              let msg = "";
              if (error.response) {
                msg = error.response.data
              } else if (error.request) {
                msg = error.request.data
              } else {
                msg = error.message;
              }
              this.alerta(msg, "error")
            });
        } else if (t.fechavencimiento == null && t.lote != null) {
          this.$axios
            .get(
              this.$hostname + this.$hName + "/fechaVencimiento/" + t.lote,
              { headers: this.$store.getters.GetheadersAxios }
            )
            .then((res) => {
              t.fechavencimiento = res.data
              console.log(t.fechavencimiento);
            })
            .catch(error => {
              console.log("Error obteniendo la fecha de vencimiento");
              console.log(error)
            });
        }
      } else {
        if (t.fechavencimiento != null && t.fechavencimiento.length == 0) {
          t.fechavencimiento = null
        }

        var e = new Date(), d = new Date(t.fechavencimiento)
        e.setMonth(e.getMonth() + 3)
        if (d < e) {
          this.alerta("Este producto esta próximo a vencerse ")
          return
        }
      }


      /** 
      if (t.fechavencimiento != null && t.fechavencimiento.length == 0) {
        t.fechavencimiento = null
      }

      var _this = this;
      setTimeout(function () {
        //  if(e!=null && e.length>10){e='2024-12-10' }
        if (t.fechavencimiento != null && t.fechavencimiento.toString().length > 10) {
          var FCSPLIT = t.fechavencimiento.split("-")
          t.fechavencimiento = `${FCSPLIT[0].substr(0, 4)}-${FCSPLIT[1]}-${FCSPLIT[2]}`
        }

        var e = new Date(), d = new Date(t.fechavencimiento)
        e.setMonth(e.getMonth() + 3)
        if (d < e) {
          _this.alerta("Este producto esta próximo a vencerse o esta vencido", 'error')
          return
        }

      }, 500);
      */
    },

    fechaVencimientoControlVenc(ITEM){

      // var BOOL= true 
      var BOOL= this.PropsInputDisabled 
     if(ITEM.producto!=null){
          BOOL = !ITEM.producto.controlVencimiento
     }

     return BOOL
      // PropsInputDisabled
    // props.item.producto != null
      // props.item.producto.controlVencimiento
      // controlVencimiento
    },


    buscarFechaPorlote(t) {
      this.$axios
        .get(
          this.$hostname + this.$hName + "/fechaVencimiento/" + BigInt(t.lote),
          { headers: this.$store.getters.GetheadersAxios }
        )
        .then((res) => {
          t.fechavencimiento = res.data
        })
        .catch(error => {
          console.log("Error obteniendo la data");
          console.log(error)
        });

    },

    newDetalle() {
      var VarAlmacen = JSON.parse(JSON.stringify(this.EntradaAlmacen))

      var detalle = {
        movimientosinventarioDetallePK: { secuencia: 0, producto: 0, unidad: 0, documento: 0 },
        fechavencimiento: null,
        cantidad: 0.00,
        costo: 0.00,
        origcosto: 0.00,
        valor: 0.00,
        impuesto: 0.00,
        precio: 0.00,
        precio2: 0.00,
        precioAnte: 0.00,
        impuestoIncluido: false,
        existencia: 0,
        id: 0,
        borrado: false,
        almacen: VarAlmacen,
        unidad: null,
        producto: null,
        codigoProducto: "",
        unidadProducto: null,
        descuentoPorciento: false,
        descuento: 0,
        oferta: 0,
        devolucion: 0,
        ofertaSelect: false
      }
      this.ListProd.push(detalle)
    },

    setImpuestoIncluido(e) {
      this.impuestoincluido = e;
      this.calcularImpuesto1()
    },

    setDescuentoIndividual(e) {
      this.descuentoIndividual = e;
      var _this = this;
      setTimeout(function () {
        _this.calcularTotales();
      }, 500);
    },

    addDetalle(unidadProducto) {
      var VarAlmacen = JSON.parse(JSON.stringify(this.EntradaAlmacen))

      var p = 0, u = 0, a = 0
      var e = {
        movimientosinventarioDetallePK: { secuencia: 0, producto: 0, unidad: 0, documento: 0 },
        fechavencimiento: unidadProducto.hasOwnProperty('fechavencimiento') && unidadProducto.fechavencimiento!=null && unidadProducto.fechavencimiento.trim().length>0? unidadProducto.fechavencimiento :null,
        cantidad: 1,
        costo: unidadProducto.costo,
        origcosto:unidadProducto.costo,
        valor: unidadProducto.costo,
        precio: unidadProducto.costo,
        precio2: unidadProducto.costo,
        precioAnte: unidadProducto.costo,
        descuento: 0.0,
        impuesto: this.calcularImpuesto(unidadProducto),
        impuestoIncluido: this.impuestoIncuidos(unidadProducto),
        id: 0,
        borrado: false,
        almacen: VarAlmacen,
        unidad: unidadProducto.unidades,
        producto: unidadProducto.productos,
        codigoProducto: "",
        existencia: unidadProducto.hasOwnProperty('existencia') && unidadProducto.existencia!=null? unidadProducto.existencia :0,
        unidadProducto: unidadProducto,
        ofertaSelect: false,
        descuentoPorciento: true,
         lote: unidadProducto.hasOwnProperty('lote') && unidadProducto.lote!=null? unidadProducto.lote :0,
      }

      var VarAlmacen = JSON.parse(JSON.stringify(this.EntradaAlmacen))

      if (unidadProducto == null) {
        return
      }
      if (unidadProducto.unidades != null && unidadProducto.unidades.codigo != undefined) {
        u = unidadProducto.unidades.codigo;
      }
      if (unidadProducto.productos != null && unidadProducto.productos.codigo != undefined) {
        p = unidadProducto.productos.codigo;
      }
      if (VarAlmacen != null && VarAlmacen.codigo != undefined) {
        a = VarAlmacen.codigo;
      }
      if (a == 0 || p == 0 || u == 0) {
        e.existencia = 0.00
      } else {
        this.findExistencia(p, u, a, e)
      }

      // var _this = this;
      // setTimeout(function(){_this.ListProd.push(e)},500)
      this.ListProd.push(e)
      this.calcularImporte(e)
    },

    //original--addDetalleSugerido
    addDetalleSugerido_Original(det) {

      var VarAlmacen = JSON.parse(JSON.stringify(this.EntradaAlmacen))
      var p = 0, u = 0, a = 0
      var e = {
        movimientosinventarioDetallePK: { secuencia: 0, producto: 0, unidad: 0, documento: 0 },
        fechavencimiento: null,
        cantidad: det.cantidad,
        costo: det.hasOwnProperty("unidadesProductos") && det.unidadesProductos.hasOwnProperty("costo") && det.unidadesProductos.costo != null ? det.unidadesProductos.costo : 0,
        origcosto:det.hasOwnProperty("unidadesProductos") && det.unidadesProductos.hasOwnProperty("costo") && det.unidadesProductos.costo != null ? det.unidadesProductos.costo : 0,
        precioAnte: det.hasOwnProperty("unidadesProductos") && det.unidadesProductos.hasOwnProperty("costo") && det.unidadesProductos.costo != null ? det.unidadesProductos.costo : 0,
        valor: det.hasOwnProperty("unidadesProductos") && det.unidadesProductos.hasOwnProperty("costo") && det.unidadesProductos.costo != null ? det.unidadesProductos.costo : 0,
        impuesto: this.calcularImpuesto(det.unidadesProductos),
        impuestoIncluido: this.impuestoIncuidos(det.unidadesProductos),
        id: 0,
        borrado: false,
        almacen: VarAlmacen,
        unidad: det.unidadesProductos.unidades,
        producto: det.unidadesProductos.productos,
        codigoProducto: "",
        existencia: 0,
        venta: det.hasOwnProperty("ventas") && det.ventas != null ? det.ventas : 0,
        // venta: det.ventas,
        unidadProducto: det.unidadesProductos,
        oferta: 0,
        devolucion: det.devolucion,
        descuento: 0.00,
        ofertaSelect: false
      }

      var VarAlmacen = JSON.parse(JSON.stringify(this.EntradaAlmacen))
      if (det.unidadesProductos == null) {
        return
      }
      if (det.unidadesProductos.unidades != null && det.unidadesProductos.unidades.codigo != undefined) {
        u = det.unidadesProductos.unidades.codigo;
      }
      if (det.unidadesProductos.productos != null && det.unidadesProductos.productos.codigo != undefined) {
        p = det.unidadesProductos.productos.codigo;
      }
      if (VarAlmacen != null && VarAlmacen.codigo != undefined) {
        a = VarAlmacen.codigo;
      }
      if (a == 0 || p == 0 || u == 0) {
        e.existencia = 0.00
      } else {
        this.findExistencia(p, u, a, e)
      }
      this.ListProd.push(e)
      this.calcularImporte(e)
    },

 addDetalleSugerido(det) {

      var VarAlmacen = JSON.parse(JSON.stringify(this.EntradaAlmacen))
      var p = 0, u = 0, a = 0
      var e = {
        movimientosinventarioDetallePK: { secuencia: 0, producto: 0, unidad: 0, documento: 0 },
        fechavencimiento: null,
        cantidad: det.cantidad,
        costo: det.hasOwnProperty("unidadesProductos") && det.unidadesProductos.hasOwnProperty("costo") && det.unidadesProductos.costo != null ? det.unidadesProductos.costo : 0,
        origcosto:det.hasOwnProperty("unidadesProductos") && det.unidadesProductos.hasOwnProperty("costo") && det.unidadesProductos.costo != null ? det.unidadesProductos.costo : 0,
        precioAnte: det.hasOwnProperty("unidadesProductos") && det.unidadesProductos.hasOwnProperty("costo") && det.unidadesProductos.costo != null ? det.unidadesProductos.costo : 0,
        valor: det.hasOwnProperty("unidadesProductos") && det.unidadesProductos.hasOwnProperty("costo") && det.unidadesProductos.costo != null ? det.unidadesProductos.costo : 0,
        impuesto: this.calcularImpuesto(det.unidadesProductos),
        impuestoIncluido: this.impuestoIncuidos(det.unidadesProductos),
        id: 0,
        borrado: false,
        almacen: VarAlmacen,
        unidad: det.unidadesProductos.unidades,
        producto: det.unidadesProductos.productos,
        codigoProducto: "",
        existencia: det.hasOwnProperty("existencia") && det.existencia != null ? det.existencia : 0,
        venta: det.hasOwnProperty("ventas") && det.ventas != null ? det.ventas : 0,
        // venta: det.ventas,
        unidadProducto: det.unidadesProductos,
        oferta: 0,
        devolucion: det.devolucion,
        descuento: 0.00,
        ofertaSelect: false
      }

      var VarAlmacen = JSON.parse(JSON.stringify(this.EntradaAlmacen))
      if (det.unidadesProductos == null) {
        return
      }
      if (det.unidadesProductos.unidades != null && det.unidadesProductos.unidades.codigo != undefined) {
        u = det.unidadesProductos.unidades.codigo;
      }
      if (det.unidadesProductos.productos != null && det.unidadesProductos.productos.codigo != undefined) {
        p = det.unidadesProductos.productos.codigo;
      }
      if (VarAlmacen != null && VarAlmacen.codigo != undefined) {
        a = VarAlmacen.codigo;
      }
      if (a == 0 || p == 0 || u == 0) {
        e.existencia = 0.00
      } 
      // else {
      //   this.findExistencia(p, u, a, e)
      // }
      this.ListProd.push(e)
      this.calcularImporte(e)
    },
    

    addDetallePedido(unidadProducto) {
      var VarAlmacen = JSON.parse(JSON.stringify(this.EntradaAlmacen))
      var p = 0, u = 0, a = 0
      var e = {
        movimientosinventarioDetallePK: { secuencia: 0, producto: 0, unidad: 0, documento: 0 },
        fechavencimiento: null,
        cantidad: unidadProducto.cantidad,
        costo: det.hasOwnProperty("unidadProducto") && det.unidadesProductos.hasOwnProperty("costo") && e.unidadProducto.costo != null ? e.unidadProducto.costo : 0,
        valor: det.hasOwnProperty("unidadProducto") && det.unidadesProductos.hasOwnProperty("costo") && e.unidadProducto.costo != null ? e.unidadProducto.costo : 0,
        precioAnte: det.hasOwnProperty("unidadProducto") && det.unidadesProductos.hasOwnProperty("costo") && e.unidadProducto.costo != null ? e.unidadProducto.costo : 0,
        origcosto:det.hasOwnProperty("unidadProducto") && det.unidadesProductos.hasOwnProperty("costo") && e.unidadProducto.costo != null ? e.unidadProducto.costo : 0,
        // costo: unidadProducto.costo,
        // valor: unidadProducto.costo,
        impuesto: this.calcularImpuesto(unidadProducto),
        impuestoIncluido: this.impuestoIncuidos(unidadProducto),
        id: 0,
        borrado: false,
        almacen: VarAlmacen,
        unidad: unidadProducto.unidades,
        producto: unidadProducto.productos,
        codigoProducto: "",
        existencia: 0,
        unidadProducto: unidadProducto,
        venta: unidadProducto.ventas,
        ofertaSelect: false
      }

      var VarAlmacen = JSON.parse(JSON.stringify(this.EntradaAlmacen))

      if (unidadProducto == null) {
        return
      }
      if (unidadProducto.unidades != null && unidadProducto.unidades.codigo != undefined) {
        u = unidadProducto.unidades.codigo;
      }
      if (unidadProducto.productos != null && unidadProducto.productos.codigo != undefined) {
        p = unidadProducto.productos.codigo;
      }
      if (VarAlmacen != null && VarAlmacen.codigo != undefined) {
        a = VarAlmacen.codigo;
      }
      if (a == 0 || p == 0 || u == 0) {
        e.existencia = 0.00
      } else {

        this.findExistencia(p, u, a, e)

      }

      // var _this = this;
      // setTimeout(function(){_this.ListProd.push(e)},500)

      this.ListProd.push(e)
    },
    async getUnidadesProductos(producto, unidad) {
      var unidadProducto = null;
      await this.$axios.get(this.$hostname + this.$hName + '/unidades-productos/find/' + producto + '/' + unidad,
        { headers: this.$store.getters.GetheadersAxios })
        .then(res => {
          unidadProducto = res.data
        });
      return unidadProducto
    },

    async getUnidadesProductos2(producto, unidad, e) {
      var unidadProducto = null;
      await this.$axios.get(this.$hostname + this.$hName + '/unidades-productos/find/' + producto + '/' + unidad,
        { headers: this.$store.getters.GetheadersAxios })
        .then(res => {
          unidadProducto = res.data
          e.unidadProducto = res.data
          // e.unidadProducto.codigoProducto= this.GetCodigoProdUni(res.data)

        });
      //  return unidadProducto
    },


    async getListOrden(listArrayProduct) {
      var LISTARRAYS = JSON.parse(JSON.stringify(listArrayProduct));
      // return
      var bar = new Promise((resolve, reject) => {
        LISTARRAYS.forEach(e => {

          this.$axios.get(this.$hostname + this.$hName + '/unidades-productos/find/' + e.producto.codigo + '/' + e.unidad.codigo,
            { headers: this.$store.getters.GetheadersAxios })
            .then(res => {
              // unidadProducto = res.data
              e.unidadProducto = res.data
              e.unidadProducto.codigoProducto = this.GetCodigoProdUni(res.data)
              e.costo = e.precio
              e.origcosto=e.precio
              e.precioAnte = e.precio
              e.ofertaSelect = e.oferta
              var VarAlmacen = JSON.parse(JSON.stringify(this.EntradaAlmacen))

              if (res.data == null) {
                return
              }
              var bar1 = new Promise((resolve1, reject) => {
                var p = 0, u = 0, a = 0
                if (res.data.unidades != null && res.data.unidades.codigo != undefined) {
                  u = res.data.unidades.codigo;
                }
                if (res.data.productos != null && res.data.productos.codigo != undefined) {
                  p = res.data.productos.codigo;
                }
                if (VarAlmacen != null && VarAlmacen.codigo != undefined) {
                  a = VarAlmacen.codigo;
                }
                if (a == 0 || p == 0 || u == 0) {
                  e.existencia = 0.00
                  resolve1()
                } else {
                  this.$axios.get(this.$hostname + this.$hName + '/unidades-productos/findExistencia/' + p + '/' + u + '/' + a,
                    { headers: this.$store.getters.GetheadersAxios })
                    .then(res => {
                      e.existencia = res.data
                      resolve1()
                    })
                }
              });

              bar1.then(() => {
                this.ListProd.push(e)
                this.calcularImporte(e)

              });

            });

        });

        resolve()
      });

      bar.then(() => {
        return LISTARRAYS;
        //this.ListProd =JSON.parse(JSON.stringify(LISTARRAYS));
      });


      //  return unidadProducto
    },



    async addDetalledatostablaFacProveedor(detalle) {
      var VarAlmacen = JSON.parse(JSON.stringify(this.EntradaAlmacen))
      var p = 0, u = 0, a = 0
      var e = {
        movimientosinventarioDetallePK: { secuencia: 0, producto: 0, unidad: 0, documento: 0 },
        fechavencimiento: detalle.fechavencimiento,
        cantidad: detalle.cantidad,
        // costo: detalle.precio,
        costo: detalle.costo,
        origcosto:detalle.costo,
        precio: detalle.precio,
        precio2: detalle.precio,
        precioAnte: detalle.precio,
        valor: detalle.valor,
        impuesto: detalle.impuesto,
        impuestoIncluido: detalle.impuestoIncluido,
        id: 0,
        borrado: false,
        descuento: detalle.hasOwnProperty("descuento") && detalle.descuento != null ? detalle.descuento : 0,
        almacen: VarAlmacen,
        unidad: (detalle.unidad == null ? (detalle.unidades == null ? null : detalle.unidades) : detalle.unidad),
        producto: (detalle.producto == null ? (detalle.productos == null ? null : detalle.productos) : detalle.producto),
        codigoProducto: '',
        existencia: 0,
        unidadProducto: null,
        ofertaSelect: detalle.hasOwnProperty('ofertaSelect') ? detalle.ofertaSelect : false,
        descuentoPorciento: detalle.hasOwnProperty('descuentoPorciento') ? detalle.descuentoPorciento : false,
        loteFabricante: detalle.hasOwnProperty('loteFabricante')?detalle.loteFabricante:''
      }
      if (detalle.producto != null && detalle.unidad != null) {
        this.getUnidadesProductos(detalle.producto.codigo, detalle.unidad.codigo).then(aa => {

          if (this.$store.getters.GetConfiguracionGeneral.configInv.usarLote) {
            aa.lote = detalle.lote
          }
          e.unidadProducto = aa

        })

      }
      if (detalle.productos != null && detalle.unidades != null) {
        this.getUnidadesProductos(detalle.productos.codigo, detalle.unidades.codigo).then(aa => {
          if (this.$store.getters.GetConfiguracionGeneral.configInv.usarLote) {
            aa.lote = detalle.lote
            // e.unidadProducto.lote =detalle.lote
          }
          e.unidadProducto = aa

        })


      }
      var VarAlmacen = JSON.parse(JSON.stringify(this.EntradaAlmacen))
      if (detalle == null) {
        return
      }
      if (detalle.unidad != null && detalle.unidad.codigo != undefined) {
        u = detalle.unidad.codigo;
      }
      if (detalle.producto != null && detalle.producto.codigo != undefined) {
        p = detalle.producto.codigo;
      }
      if (detalle.unidades != null && detalle.unidades.codigo != undefined) {
        u = detalle.unidades.codigo;
      }
      if (detalle.productos != null && detalle.productos.codigo != undefined) {
        p = detalle.productos.codigo;
      }
      if (VarAlmacen != null && VarAlmacen.codigo != undefined) {
        a = VarAlmacen.codigo;
      }
      if (a == 0 || p == 0 || u == 0) {
        e.existencia = 0.00
      } else {
        this.findExistencia(p, u, a, e)
      }
      // var _this = this;
      // setTimeout(function(){_this.ListProd.push(e)},500)
      this.ListProd.push(e)
      this.blurItbsImpuestoValidarCalculo(e)
    },

    async addDetalleOrdenAFactura(detalle) {
      var VarAlmacen = JSON.parse(JSON.stringify(this.EntradaAlmacen))
      var p = 0, u = 0, a = 0
      var descripcionLimpiaIa = detalle && detalle.descripcionLimpia
        ? String(detalle.descripcionLimpia).trim()
        : (detalle && detalle.descripcionIa ? String(detalle.descripcionIa).trim() : "")
      var productoFila = (detalle.producto == null
        ? (detalle.productos == null ? null : detalle.productos)
        : detalle.producto)
      var unidadFila = (detalle.unidad == null
        ? (detalle.unidades == null ? null : detalle.unidades)
        : detalle.unidad)
      var productoNoEncontrado = detalle.esDetalleIa === true && (
        !productoFila || !productoFila.codigo || detalle.estadoRevision === "SIN"
      )
      var cantidadFila = productoNoEncontrado ? 0 : detalle.cantidad
      var precioFila = productoNoEncontrado ? 0 : detalle.precio
      var valorFila = productoNoEncontrado ? 0 : detalle.valor
      var impuestoFila = productoNoEncontrado ? 0 : detalle.impuesto
      var descuentoFila = productoNoEncontrado
        ? 0
        : (detalle.hasOwnProperty("descuento") && detalle.descuento != null ? detalle.descuento : 0)
      var e = {
        movimientosinventarioDetallePK: { secuencia: 0, producto: 0, unidad: 0, documento: 0 },
        fechavencimiento: productoNoEncontrado ? null : detalle.fechavencimiento,
        cantidad: cantidadFila,
        costo: precioFila,
        origcosto: precioFila,
        precio: precioFila,
        precio2: precioFila,
        precioAnte: precioFila,
        valor: valorFila,
        impuesto: impuestoFila,
        impuestoIncluido: detalle.impuestoIncluido,
        id: 0,
        borrado: false,
        descuento: descuentoFila,
        almacen: VarAlmacen,
        unidad: productoNoEncontrado ? null : unidadFila,
        producto: productoNoEncontrado ? null : productoFila,
        codigoProducto: productoNoEncontrado ? '' : (detalle.codigoProducto || ''),
        existencia: 0,
        unidadProducto: null,
        ofertaSelect: productoNoEncontrado
          ? false
          : (detalle.hasOwnProperty('ofertaSelect') ? detalle.ofertaSelect : false),
        descuentoPorciento: productoNoEncontrado
          ? false
          : (detalle.hasOwnProperty('descuentoPorciento') ? detalle.descuentoPorciento : false),
        loteFabricante: productoNoEncontrado
          ? ''
          : (detalle.hasOwnProperty('loteFabricante') ? detalle.loteFabricante : ''),
        // Campos IA: limpia visible; montos en 0 si no hay producto (total no se altera)
        esDetalleIa: detalle.esDetalleIa === true,
        descripcionIa: descripcionLimpiaIa,
        descripcionLimpia: descripcionLimpiaIa,
        estadoRevision: productoNoEncontrado ? "SIN" : (detalle.estadoRevision || null)
      }
      if (!productoNoEncontrado && detalle.producto != null && detalle.unidad != null) {
        this.getUnidadesProductos(detalle.producto.codigo, detalle.unidad.codigo).then(aa => e.unidadProducto = aa)
      }
      if (!productoNoEncontrado && detalle.productos != null && detalle.unidades != null) {
        this.getUnidadesProductos(detalle.productos.codigo, detalle.unidades.codigo).then(aa => e.unidadProducto = aa)
      }
      var VarAlmacen = JSON.parse(JSON.stringify(this.EntradaAlmacen))
      if (detalle == null) {
        return
      }
      if (e.unidad != null && e.unidad.codigo != undefined) {
        u = e.unidad.codigo;
      }
      if (e.producto != null && e.producto.codigo != undefined) {
        p = e.producto.codigo;
      }
      if (VarAlmacen != null && VarAlmacen.codigo != undefined) {
        a = VarAlmacen.codigo;
      }
      if (a == 0 || p == 0 || u == 0) {
        e.existencia = 0.00
      } else {
        this.findExistencia(p, u, a, e)
      }
      this.ListProd.push(e)
      this.calcularImporte(e)
    },
    async addDetalleDevolucion(detalle) {
      var VarAlmacen = JSON.parse(JSON.stringify(this.EntradaAlmacen))
      var p = 0, u = 0, a = 0
      var unidadesProductos = null
      var e = {
        factproPk: detalle.hasOwnProperty('factproPk') ? detalle.factproPk : null,
        noFactura: detalle.hasOwnProperty('factura') ? detalle.factura + "" : "",
        factura: detalle.hasOwnProperty('factura') ? detalle.factura : null,
        movimientosinventarioDetallePK: { secuencia: 0, producto: 0, unidad: 0, documento: 0 },
        fechavencimiento: detalle.fechavencimiento!=null? detalle.fechavencimiento: null,
        cantidad: detalle.cantidad,
        costo: detalle.costo,
        origcosto:detalle.costo,
        precio: detalle.costo,
        precio2: detalle.costo,
        precioAnte: detalle.costo,
        valor: detalle.valor,
        impuesto: detalle.impuesto,
        id: 0,
        borrado: false,
        descuento: 0.00,
        almacen: detalle.almacen,
        unidad: detalle.unidades,
        producto: detalle.productos,
        codigoProducto: '',
        existencia: 0,
        unidadProducto: null,
        ofertaSelect: false,
        loteFabricante: detalle.hasOwnProperty('loteFabricante')?detalle.loteFabricante:''

      }
      this.getUnidadesProductos(detalle.productos.codigo, detalle.unidades.codigo).then(a => e.unidadProducto = a)
      var VarAlmacen = JSON.parse(JSON.stringify(this.EntradaAlmacen))
      if (detalle == null) {
        return
      }
      if (detalle.unidades != null && detalle.unidades.codigo != undefined) {
        u = detalle.unidades.codigo;
      }
      if (detalle.productos != null && detalle.productos.codigo != undefined) {
        p = detalle.productos.codigo;
      }
      if (VarAlmacen != null && VarAlmacen.codigo != undefined) {
        a = VarAlmacen.codigo;
      }
      if (a == 0 || p == 0 || u == 0) {
        e.existencia = 0.00
      } else {

        this.findExistencia(p, u, a, e)

      }
      // var _this = this;
      // setTimeout(function(){_this.ListProd.push(e)},500)
      this.ListProd.push(e)
      this.calcularImporte(e)
    },
    RecCrearProducto(e) {
      this.dialogCrearProducto = e.estado
    },

   async RecAgregarProducto(e) {
      if (e.estado == 'cerrar') {
        this.dialogAddProducto = e.false
      }
      if (e.estado == 'datos') {
        this.addDetalle(e.datos)
        var _this = this;
        setTimeout(function () {
          _this.calcularTotales();
        }, 500);
        // this.calcularTotales();
        //loaderTablaCargar

          var OBJ_NEW = this.ListProd.filter((ee) =>
            ee.producto == null
            && ee.unidad == null
            && !ee.esDetalleIa
            && !this.descripcionLimpiaFilaIa(ee)
          );
          await Promise.all(OBJ_NEW.map(async (element) => {
            const index = this.ListProd.indexOf(element)
              this.ListProd.splice(index, 1)
          }));
          // console.log("ObjNew--",OBJ_NEW)


             /**/ setTimeout(function () {
                var ULT_LINE = _this.ListProd.length - 1
                if(_this.ListProd[ULT_LINE].producto!=null&& _this.ListProd[ULT_LINE].unidad!=null){
                _this.AddNewRowListProd(e)
                }
              }, 500);

        this.loaderTablaCargar()
      }
    },


verifAddNewrow(){
  /**/
var _this = this;
setTimeout(function () {
                var ULT_LINE = _this.ListProd.length - 1
                if(_this.ListProd[ULT_LINE].producto!=null&& _this.ListProd[ULT_LINE].unidad!=null){
               // _this.AddNewRowListProd(e)
               _this.AddNewRowListProd(_this.ListProd[ULT_LINE])
                }
              }, 500);

        this.loaderTablaCargar()

},



    VerOtroAlmacenItem(e) {
      var obj = {
        unidadProducto: e.unidadProducto,
        desde: this.Fecdesde,
        hasta: this.Fechasta
      }
      this.$axios
        .post(this.$hostname + this.$hName + "/ordenescompras/ProductoAlmacExistVenta", obj, {
          headers: this.$store.getters.GetheadersAxios,
        })
        .then((res) => {
          obj.ListaAlmacen = res.data
          this.OtroAlmacen = JSON.parse(JSON.stringify(obj))
          this.dialogVerOtroAlmacen = true
        })
        .catch((error) => { console.log('Catch---') });
      /* this.OtroAlmacen = JSON.parse(JSON.stringify(obj))
       console.log(e)
       console.log('-----')
       console.log(this.OtroAlmacen)
       this.OtroAlmacen.ListaAlmacen = [{ venta: 5000, almacen: 'principal', existencion: 400 }, { venta: 800, almacen: 'Secuendario', existencion: 200 }]
       this.dialogVerOtroAlmacen = true*/
    },

    eliminarItem(e) {
      if (e != null) {
        const index = this.ListProd.indexOf(e)
        var c = confirm('¿ Desea eliminar este Registro ?') && this.ListProd.splice(index, 1)
        if (c != false) {
          this.calcularTotales()
        }
      }
    },
    RedireccionFocus(e) {
      this.verifAddNewrow()
      var _this = this;
      setTimeout(function () { _this.$refs[e].focus() }, 500)
    },
    RedireccionBlur(e) {
      this.verifAddNewrow()
      var _this = this;
      setTimeout(function () { _this.$refs[e].blur() }, 500)
    },
    PosicionFocus(e) {

      var NUMPOSICIO = (this.ListProd.length / this.TbPaginator.itemsPerPage)
      if (NUMPOSICIO > 1) {
        this.TbPaginator.pageCount = (parseInt(NUMPOSICIO) + 1)
      }
      if (this.VarKeyCode == 40) {
        //var ok = e.length - 1
        var ok = this.ListProd.length - 1
        if (this.TbPaginator.page != this.TbPaginator.pageCount) {
          this.TbPaginator.page = this.TbPaginator.pageCount
        }
        /*else{
          if(this.ListProd.length>this.TbPaginator.itemsPerPage){
           //var NUMPOSICIO=(this.ListProd.length/this.TbPaginator.itemsPerPage)
           // this.TbPaginator.page=parseInt(NUMPOSICIO)
           // this.TbPaginator.pageCount=parseInt(NUMPOSICIO)
          }
        }*/

        this.RedireccionFocus('codigo' + ok)
      }
      this.VarKeyCode = 0
    },
    NewObjetoProducto(e) {
      var VarAlmacen = JSON.parse(JSON.stringify(this.EntradaAlmacen))
      e.almacen = VarAlmacen
      e.costo = 0
      e.cantidad = 1
      e.producto = null
      e.impuesto = 0
      e.impuestoIncluido = false,
        e.existencia = 0
      e.valor = 0
    },
    findExistencia(p, u, a, e) {
      
      this.$axios.get(this.$hostname + this.$hName + '/unidades-productos/findExistencia/' + p + '/' + u + '/' + a,
        { headers: this.$store.getters.GetheadersAxios })
        .then(res => { e.existencia = res.data })
    },
    impuestoIncuidos(e) {
      return this.impuestoIncluido
    },
    calcularImpuesto(unidadProducto) {
      if (unidadProducto.productos == null) {
        return 0.00
      }
      if (unidadProducto.productos.impuesto == null) {
        return 0.00
      }
      var tasa = (unidadProducto.productos.impuesto.tasa == null || unidadProducto.productos.impuesto.tasa == 0 ? 1 : unidadProducto.productos.impuesto.tasa) / 100
      var valImpuesto = unidadProducto.costo * tasa;
      return valImpuesto
    },
    AsignarObjetoProducto(e, Obj) {
      var VarAlmacen = JSON.parse(JSON.stringify(this.EntradaAlmacen))
      e.unidadProducto = JSON.parse(JSON.stringify(Obj))
      e.almacen = VarAlmacen
      e.costo = Obj.costo
      e.origcosto= Obj.costo
      e.precio = Obj.costo
      e.precio2 = Obj.costo
      e.precioAnte = Obj.costo
      e.cantidad = 1
      e.producto = JSON.parse(JSON.stringify(Obj.productos))
      e.unidad = JSON.parse(JSON.stringify(Obj.unidades))
      e.impuesto = this.calcularImpuesto(e.unidadProducto)
      e.impuestoIncluido = this.impuestoIncuidos(e.unidadProducto)
      this.findExistencia(Obj.unidadesProductosPK.producto, Obj.unidadesProductosPK.unidad, e.almacen.codigo, e)
      e.valor = e.cantidad * (e.costo + e.impuesto)
      this.RedireccionBlur('codigo' + e.indx)
      e.lote = Obj.lote

      var BOOLFOCUS = (this.PropsFacturaProveedor == true && Obj.productos.hasOwnProperty('controlVencimiento') && Obj.productos.controlVencimiento == true)
      if (BOOLFOCUS == true) {
        this.RedireccionFocus('fechavencimiento' + e.indx)
      } else {
        this.RedireccionFocus('cantidad' + e.indx)
      }


    },
    limpiar() {
      this.ListProd = [];
    },

OnKeyDownProducCombox(e,opc,index){
var _this = this;
var ULT_LINE = this.ListProd.length - 1

//ArrowUp
 if(e.keyCode == 38){
  if(index> 0){
 setTimeout(function () {

if(_this.RproductoBuscados.length==0){
  _this.RedireccionBlur(opc+"" + (index)) 
  _this.RedireccionFocus(opc+"" + (index-1))
}

    }, 500);

}

 }
 // ArrowDown
 if(e.keyCode == 40){
if(index!= this.ListProd[ULT_LINE].indx){
   setTimeout(function () {
if(_this.RproductoBuscados.length==0){
    _this.RedireccionBlur(opc+"" + (index)) 
    _this.RedireccionFocus(opc+"" + (index+1))
  }

   }, 500);

}
 }






      /* if(e.keyCode == 38 ||  e.keyCode == 40){
          if (this.selectProducto == null && this.ListItems.length != 0) {
          this.selectProducto = JSON.parse(JSON.stringify(this.ListItems[0]));
          return 0;
        }
        }*/


},


    changeSelectProduc(e) {
      var BOOL_DIST_FARM=this.$store.getters.GetConfiguracionGeneral.config.distribuidoraFarmaceutico
      this.RproductoBuscados = []
      this.NewObjetoProducto(e)
      if (e.unidadProducto != null && e.unidadProducto.hasOwnProperty('costo')) {
        this.AsignarObjetoProducto(e, e.unidadProducto)
     
      } else {


var V_LOTE=0
      if(e.unidadProducto !=null  && this.PropsDevolucion==true && BOOL_DIST_FARM==true ){
  const letras = (e.unidadProducto.trim().match(/[a-zA-Z]/g) || []).length;
        const numeros = (e.unidadProducto.trim().match(/[0-9]/g) || []).length;

        if (this.$store.getters.GetConfiguracionGeneral.configInv.usarLote) {
        V_LOTE = parseInt(e.unidadProducto.substring(10));

          if(BOOL_DIST_FARM==true && letras==3 && numeros==15 || numeros==18){
            V_LOTE =parseInt(numeros==15?e.unidadProducto.substr(8,3):e.unidadProducto.substr(10,4))
            }
        }

        var _this = this;
         setTimeout(function () {
          var OBJ_PROD={
          lote: V_LOTE,
          dataProd:e
           } 
          _this.$emit("DataInfProdChange",OBJ_PROD)
          }, 800);
   
}


        var link = this.$hostname + this.$hName + '/unidades-productos/' + e.unidadProducto + '/false/buscar';
        this.$axios.get(link,
          { headers: this.$store.getters.GetheadersAxios })
          .then(res => {
            var V_LIS_PRO_OBJ= res.data.map(item => ({...item,lote:V_LOTE}));
            this.RproductoBuscados = V_LIS_PRO_OBJ;
            if (V_LIS_PRO_OBJ.length == 1) {
              this.AsignarObjetoProducto(e, V_LIS_PRO_OBJ[0])
              this.RproductoBuscados = []

            }
          })
      }


      var _this = this;
              setTimeout(function () {
                var ULT_LINE = _this.ListProd.length - 1
                if(_this.ListProd[ULT_LINE].producto!=null&& _this.ListProd[ULT_LINE].unidad!=null){
                _this.AddNewRowListProd(e)
                }
              }, 500);
                  
    },

    BlurTabSelectProduc(e) {
      if (this.PropsDevolucion === true) {
        if (this.$store.getters.GetConfiguracionGeneral.configInv.usarLote == true) {
          //e.unidadProducto.codigoProducto!=null&& e.unidadProducto.codigoProducto.length==14
          //var BOO_COD_BARR = e.lote != null && e.lote.trim().length > 0 && !isNaN(e.lote);
        
          if(e.lote!=null&&typeof e.lote === "string" && e.lote.trim().length > 0){
            e.lote = parseInt(e.lote)
          }
          var BOO_COD_BARR= e.lote!=null && typeof e.lote === "number" && !isNaN(e.lote);


          if (BOO_COD_BARR === true) {
            var _this = this;
            setTimeout(function () {
              _this.buscarFechaPorlote(e);
            }, 500);
          }

        }
      }


      if (this.RproductoBuscados.length > 0) {
        this.AsignarObjetoProducto(e, this.RproductoBuscados[0])
        this.RproductoBuscados = []
        if(this.PropsOrdenCompra==false){
          this.RedireccionBlur('Almacen' + e.indx)
        }
        var BOOLFOCUS = (this.PropsFacturaProveedor == true && e.producto.hasOwnProperty('controlVencimiento') && e.producto.controlVencimiento == true)
        if (BOOLFOCUS == true) {
          this.RedireccionFocus('fechavencimiento' + e.indx)
        } else {
          this.RedireccionFocus('cantidad' + e.indx)
        }
        
        //this.RedireccionFocus('cantidad' + e.indx)
        return
      }
      if (e.unidadProducto == null && this.RproductoBuscados.length == 0) {
        if(this.PropsOrdenCompra==false){
        this.RedireccionBlur('Almacen' + e.indx)
        }
        //this.alerta("Debe seleccionar un producto", "error")
      }
      if (e.unidadProducto != null && !e.unidadProducto.hasOwnProperty('costo') && this.RproductoBuscados.length == 0) {
       if(this.PropsOrdenCompra==false){
        this.RedireccionBlur('Almacen' + e.indx)
       }
        this.alerta("Debe seleccionar un producto", "error")
        var VarAlmacen = JSON.parse(JSON.stringify(this.EntradaAlmacen))
        e.unidadProducto = null
        e.almacen = VarAlmacen
        e.costo = 0
        e.cantidad = 1
        e.producto = null
        e.impuesto = 0
        e.impuestoIncluido = false,
          e.existencia = 0
        e.valor = 0
      }

      this.verifAddNewrow()
      this.calcularTotales()

    },

  
    AddNewRowListProd(e) {
      
      var VarAlmacen = JSON.parse(JSON.stringify(this.EntradaAlmacen))
      var detalle = {
        indx: e.indx + 1,
        movimientosinventarioDetallePK: { secuencia: 0, producto: 0, unidad: 0, documento: 0 },
        fechavencimiento: null,
        cantidad: 0.00,
        costo: 0.00,
        origcosto: 0.00,
        valor: 0.00,
        precio: 0.00,
        precio2: 0.00,
        precioAnte: 0.00,
        impuesto: 0.00,
        impuestoIncluido: false,
        existencia: 0,
        id: 0,
        borrado: false,
        almacen: VarAlmacen,
        unidad: null,
        producto: null,
        codigoProducto: "",
        unidadProducto: null,
        ofertaSelect: false,
        descuento: 0.00,
        descuentoPorciento: false
      }
      this.ListProd.push(detalle)
      this.RedireccionBlur('codigo' + e.indx)
    },
    isOferta(e) {
      if (e.ofertaSelect) {
        e.precio = 0
        e.costo2 = 0
        e.costo = 0
        e.precioAnte = 0
      } else {
        e.precio = e.precio2
        e.costo = e.precio2
        e.precioAnte = e.precio2
      }
      this.calcularImporte(e)

      var _this = this;
      setTimeout(function () {
        _this.calcularTotales();
      }, 500);

    },
    OnKeyupAddRowProducCombox(e) {
      if (this.RproductoBuscados.length == 0) {
        this.AddNewRowListProd(e);
        this.VarKeyCode = 40
      }
    },
    calcularTotales() {
      this.TotalProd.impuesto = 0.00
      this.TotalProd.importe = 0.00
      this.TotalProd.descuento = 0.00
      this.ListProd.forEach(dt => {
        // this.TotalProd.impuesto += (dt.impuesto * dt.cantidad)
        this.TotalProd.impuesto += (dt.impuesto)

        this.TotalProd.importe += dt.valor
        // this.TotalProd.descuento += dt.descuento
        if (dt.hasOwnProperty('desctotal')) {
          this.TotalProd.descuento += dt.desctotal
        }

      });

      this.TotalProd.importe -= this.descuentoIndividual

      this.$emit("DataTotalList", this.TotalProd)
    },
    calcularDescuento(items) {
      if (items.costo == 0) {
        return 0.00;
      }
      if (items.descuentoPorciento) {
        //return items.costo * (items.descuento / 100);
        return ((items.cantidad * items.costo) * (items.descuento / 100));
      } else {
        return items.descuento;
      }
    },
    setCostoPrecioAnteKeyinput(e) {

      if (this.PropsFacturaProveedor == false) {
        e.precioAnte = e.costo
      }
      
        e.origcosto = e.costo

    },

    blurCostoValidarPrecioCosto(e) {

      if (this.PropsFacturaProveedor == true && e.precioAnte > e.costo) {
        //23/9/2023:1711
        // e.costo=JSON.parse(JSON.stringify(e.precioAnte))
      }
      if (this.PropsFacturaProveedor == true && e.precioAnte < e.costo) {
        //27/07/2024:2281
        // e.costo=JSON.parse(JSON.stringify(e.precioAnte))
      }

      this.verifAddNewrow()
      this.calcularImporte(e)
    },

    blurPrecioValidarPrecioCosto(e) {

      if (e.precioAnte > e.costo) {
        e.costo = JSON.parse(JSON.stringify(e.precioAnte))
      }
      this.verifAddNewrow()
      this.calcularImporte(e)
    },

    calcularImporte(el) {
      if (el.producto != null) {
        var tasa = (el.producto.impuesto == null ? 0 : el.producto.impuesto.tasa) / 100

        el.impuestoIncluido = JSON.parse(JSON.stringify(this.impuestoincluido))

        if (el.impuestoIncluido == false) {
          var DESCUENTO_VALOR = 0
          if (el.descuentoPorciento == true) {
            // desc$=( ((Cant*Prec)*desc%)/100 )
            DESCUENTO_VALOR = (((el.cantidad * el.precioAnte) * el.descuento) / 100)
          } else {
            DESCUENTO_VALOR = (el.descuento)
          }
          el.desctotal = DESCUENTO_VALOR
          // impuesto= (((Cant*Prec)-desc)*0.18)
          el.impuesto = (((el.cantidad * el.precioAnte) - DESCUENTO_VALOR) * tasa)
          // importe=((Cant*Prec)-desc)+impuesto)
          el.valor = (((el.cantidad * el.precioAnte) - DESCUENTO_VALOR) + el.impuesto)
        } else {
          var PRECIO = JSON.parse(JSON.stringify((el.precioAnte / (1 + (tasa)))))
          var DESCUENTO_VALOR = 0
          if (el.descuentoPorciento == true) {
            // desc$=( ((Cant*Prec)*desc%)/100 )
            DESCUENTO_VALOR = (((el.cantidad * PRECIO) * el.descuento) / 100)
          } else {
            DESCUENTO_VALOR = (el.descuento)
          }
          el.desctotal = DESCUENTO_VALOR
          el.precio = JSON.parse(JSON.stringify(PRECIO))
          if (PRECIO > el.costo) {
            el.costo = JSON.parse(JSON.stringify(PRECIO))
          }

          el.impuesto = (((el.cantidad * PRECIO) - DESCUENTO_VALOR) * tasa)
          el.valor = (((el.cantidad * PRECIO) - DESCUENTO_VALOR) + el.impuesto)
          /* el.precio=(el.precio / (1 + (tasa)))
           el.costo=el.precio
           el.impuesto=( ((el.cantidad*el.precio)- DESCUENTO_VALOR)*tasa )
           el.valor=( ((el.cantidad*el.precio)-DESCUENTO_VALOR)+el.impuesto )
            return*/
        }

        this.calcularTotales()

      }

      /*
      Proceso Anterior
      var tasa = el.producto.impuesto == null ? 0 : el.producto.impuesto.tasa
      if (tasa > 0) {
        el.impuestoIncluido = this.impuestoincluido
        if (this.impuestoincluido) {
          el.costo = (el.precio / (1 + (tasa / 100)))
          el.impuesto = el.precio - el.costo
          el.valor = (el.cantidad * el.precio)
        } else {
          el.impuesto = el.precio * (tasa / 100)
          el.valor = (el.cantidad * el.precio) + (el.cantidad * el.impuesto)
          el.costo = el.precio
        }
      } else {
        el.costo = el.precio
      }*/




    },

    blurItbsImpuestoValidarCalculo(el) {

      if (this.PropsFacturaProveedor == true) {
        if (el.producto != null) {
          var tasa = (el.producto.impuesto == null ? 0 : el.producto.impuesto.tasa) / 100
          el.impuestoIncluido = JSON.parse(JSON.stringify(this.impuestoincluido))
          var DESCUENTO_VALOR = 0
          if (el.impuestoIncluido == false) {
            if (el.descuentoPorciento == true) {
              DESCUENTO_VALOR = (((el.cantidad * el.precioAnte) * el.descuento) / 100)
            } else {
              DESCUENTO_VALOR = (el.descuento)
            }
            el.desctotal = DESCUENTO_VALOR
            el.valor = (((el.cantidad * el.precioAnte) - DESCUENTO_VALOR) + el.impuesto)
          } else {
            var PRECIO = JSON.parse(JSON.stringify((el.precioAnte / (1 + (tasa)))))
            if (el.descuentoPorciento == true) {
              DESCUENTO_VALOR = (((el.cantidad * PRECIO) * el.descuento) / 100)
            } else {
              DESCUENTO_VALOR = (el.descuento)
            }
            el.desctotal = DESCUENTO_VALOR
            el.precio = JSON.parse(JSON.stringify(PRECIO))
            if (PRECIO > el.costo) {
              el.costo = JSON.parse(JSON.stringify(PRECIO))
            }

            el.valor = (((el.cantidad * PRECIO) - DESCUENTO_VALOR) + el.impuesto)

          }

          this.calcularTotales()

        }
      }


    },


    calcularImpuesto1() {
      this.ListProd.forEach(el => {
        if (el.producto != null) {
          /*el.precio = JSON.parse(JSON.stringify(el.precio2))
          el.precioAnte = JSON.parse(JSON.stringify(el.precio2))
          el.costo = JSON.parse(JSON.stringify(el.precio2))*/
           el.precio = JSON.parse(JSON.stringify(el.precioAnte))
         // el.precioAnte = JSON.parse(JSON.stringify(el.precioAnte))
          el.costo = JSON.parse(JSON.stringify(el.precioAnte))
          this.calcularImporte(el)

         // console.log('Verr-->', el.precio )
//origcosto
          //Antes proceso
          /*   var tasa = el.producto.impuesto == null ? 0 : el.producto.impuesto.tasa
             if (tasa > 0) {
               el.impuestoIncluido = this.impuestoincluido
               if (this.impuestoincluido) {
                 el.costo = (el.precio / (1 + (tasa / 100)))
                 el.impuesto = el.precio - el.costo
                 el.valor = (el.cantidad * el.precio)
               } else {
                 el.impuesto = el.precio * (tasa / 100)
                 el.valor = (el.cantidad * el.precio) + (el.cantidad * el.impuesto)
                 el.costo = el.precio
               }
             }*/
        }

      });
      this.calcularTotales();
    },

    VerificarCantidad(e) {
      if (this.PropsDespachoPedido == true && e.cantidad != e.cantidadpedida) {
        this.alerta("La cantidad pedida es diferente a la cantidad despachada", "warning");
      }
    },


    async ActualizarAlmacenEnTabla() {

      await Promise.all(this.ListProd.map(async (e) => {
        // this.ListProd.forEach(e => {
        e.almacen = this.EntradaAlmacen
        if (e.unidadProducto != null && e.unidadProducto.hasOwnProperty('costo')) {
          this.findExistencia(e.unidadProducto.unidadesProductosPK.producto, e.unidadProducto.unidadesProductosPK.unidad, this.EntradaAlmacen.codigo, e)
        }
        // });
      }));

      this.$emit("DataActAlmacen", false)
    },


    totalesNuevo() {

      this.TotalProd = {
        cantidad: 0.00,
        cantExit: 0.00,
        costo: 0.00,
        impuesto: 0.00,
        descuento: 0.00,
        importe: 0.00
      }
    },




    // Llamar a una función en un componente secundario para los permisos de usuario.
    funcionValidaPermisoPv(e) {

      var Sudo = this.$store.getters.GetdatosInfUsu.usuario.sudo
      var permiso = this.$store.getters.GetdatosInfUsu.usuario.usuarioPermisoPvList

      //if (Sudo == false) { }
      var obj = {
        accion: JSON.parse(JSON.stringify(e)),
        Permiso: permiso,
        Sudo: Sudo
      }
      this.$refs.RefPvMenuOpcionBotones.ClickAccionPadreEjecut(obj)

    },

    DataRetornMenuOpcBotonesPermisosPv(e) {

    },

    DataRetornPadrePermisoPv(e) {
      //Permite Cambiar Cantidad a producto"
      if (e == 'AccBtnAgregarProductoTabla') {
        // this.EjecutarPermisoPv = true
        var _this = this;
        //var OBJDATA=JSON.parse(JSON.stringify(this.ObjEjecPermisoPv)) 
        //this.ObjEjecPermisoPv=null
        setTimeout(function () {
          _this.OpenAddProducto();
          // _this.EjecutarPermisoPv = false
        }, 500);
        return;
      }
    },


    cargarPaginacionAll(e) {
      this.TbPaginator = JSON.parse(JSON.stringify(e))
    },


    loaderTablaCargar() {
      this.loaderTabla = true
      var _this = this;
      setTimeout(function () { _this.loaderTabla = false }, 900);
    },

    /**
     * Texto limpio IA cuando no hay producto matched (para pintar la columna PRODUCTO).
     */
    descripcionLimpiaFilaIa(item) {
      if (!item)
        return "";
      var limpia = item.descripcionLimpia || item.descripcionIa || "";
      if (typeof limpia !== "string")
        return "";
      return limpia.trim();
    },

    VerificarPedirNombre(e) {
      var BOOL_DISABLED=true;

      if(e.producto!=null&& e.producto.hasOwnProperty('pedirNombre') && e.producto.pedirNombre!=null && e.producto.pedirNombre==true){
        BOOL_DISABLED=false
      }
      return BOOL_DISABLED
    },

    focuFactura(e){

      console.log('Inf-focuFactura-->',e)
      var BOOL_DIST_FARM=this.$store.getters.GetConfiguracionGeneral.config.distribuidoraFarmaceutico
      if(e.producto!=null &&BOOL_DIST_FARM==true && this.PropsDevolucion==true){
        
         var _this = this;
         setTimeout(function () {
          var OBJ_PROD={
          lote: e.lote,
          dataProd:e
           } 
          _this.$emit("DataInfProdChange",OBJ_PROD)
          }, 800);
      }
    },

blurTextFielLoteFabricante(e){
if(e.loteFabricante!=null && e.loteFabricante.length>0){
  e.loteFabricante=e.loteFabricante.toUpperCase()
}
},


keyRightLeft(e){
 //ArrowRight:39
        if (e.keyCode == 39) {
          if (this.ListProd.length != 0) {
            if (this.TbPaginator.pageStop != this.TbTotalItem) {
              this.TbPaginator.page = this.TbPaginator.page + 1
              var _this = this
              setTimeout(function () {
              //  _this.selectProducto = JSON.parse(JSON.stringify(_this.ListItems[0]))
              _this.loaderTablaCargar()
              _this.$refs.RefTextFieldSearchBuscarProd.focus()
              }, 500)
              return 0
            }
          }
        }

        //ArrowLeft:37
        if (e.keyCode == 37) {
          if (this.ListProd.length != 0) {
            if (this.TbPaginator.pageStart > 0) {
              this.TbPaginator.page = this.TbPaginator.page - 1
              var _this = this
              setTimeout(function () {
                _this.loaderTablaCargar()
                _this.$refs.RefTextFieldSearchBuscarProd.focus()
              //  _this.selectProducto = JSON.parse(JSON.stringify(_this.ListItems[0]))
              }, 500)
              return 0
            }
          }
        }


},

getCrearCont(){

  var _this = this
          setTimeout(function() {
            _this.$emit("blurGetContabilidad")
          }, 500)

  
},

    alerta(e, l) {
      if (l == "bien") {
        (this.aalert.estado = true),
          (this.aalert.color = "success"),
          (this.aalert.nombre = e),
          (this.aalert.type = "success");

        this.newwnuevo();
      }

      if (l == "error") {
        (this.aalert.estado = true),
          (this.aalert.color = "error"),
          (this.aalert.nombre = e),
          (this.aalert.type = "error");

        this.ejecucion = true;
      }


      if (l == "warning") {
        (this.aalert.estado = true),
          (this.aalert.color = "warning"),
          (this.aalert.nombre = e)
            (this.aalert.type = "warning");

        this.ejecucion = true;
      }


    },

    hasPermisoCrearProducto(){
      try {
        let permisos = this.$store.getters.GetDataRouter
        permisos = permisos.filter((item) => item.codigo == 4)
        let prob = permisos[0].items.filter((modulo) => modulo.codigo == 253)

        return prob.length == 1

      } catch {
        return false
      }
    },
  },

  computed: {

    ActDescBtn() {

      //if(this.ProsActuAlmacen==true){

      //this.ActualizarAlmacenEnTabla()

      //}

      if (this.ListProd.length == 0 && !this.omitirFilaVaciaAutomatica) {
        this.newDetalle()
      }
    }


  }


}
</script>

<style></style>